var cusId = "";
var data = "";
var overlay = "";
var DigilockerData = "";
const KYC_DIGILOCKER = "DIGILOCKER";
const KYC_SMS = "SMS_LINK";
var select = "";
var option = "";
var parentalFlow = false;
var langRecieved = "ENGLISH";
var langFlag = 0;
var cburl = "";
const keyTranslations = {
  Purpose: "Purpose",
  "Data type": "Data type",
  Duration: "Duration",
  "Processing activity": "Processing activity",
  "Used by": "Used by",
  "Data item": "Data item",
  Id: "Id",
};

var digilockerClientId = "";
var digilockerSecret = "";
var digilockercodeVerifier = "";
var digilockerredirectUri = "";
var finalSelectedLanguage = "ENGLISH";

var backBtn = "";
var checkbox = "";
var btn1BackgroundColor = ""; //Save My choicves , Cancel
var btn1FontColor = "";
var btn2BackgroundColor = ""; //AllowAll,Verify,next
var btn2FontColor = "";
var cancelBtn = "";
var nextBtn = "";
var verifyBtn = "";
var selectedKYCMethod = "";
var doc_name = "";
var doc_id = "";
var TopDesc = "";

var translatedLabel = "Customer ID";
var labelSpan = "";
var ConsentAllow = "";
var withdrawLine = "";
var clickHere = "";
var requiredLabel = "";
var documentLink = "";
var label = "";
var label2 = "";
var title = "";
var content = "";
var content2 = "";
var checkbox2 = "";
var checkboxLabel = "";
var badge = "";
var pdfUrl = "";
var topDesc = "";
var rightsDesc = "";
var permissionText = "";
var parentalControl = "";
var dataItemToBeShown = "";
var processActivityNameToBeShown = "";
var idshown = false;
var processorNameToBeShown = "";
var validitytoBeShown = "";
var logoUrl = "";
var saveBtn = "";
var allowBtn = "";
var isParental = false;
var parentIdentity = "";
var parentIdentityType = "";
var parentName = "";
var theme = "";
var cardBackgroundColor = "";
var buttonBackgroundColor = "";
var cardFontColor = "";
var buttonFontColor = "";
var linkFontColor = "";
var fontFamily = "system-ui"; // replaced by the tenant font once it loads
var fontStyle = "normal";
var mainAccordionBackgroundColor = "";
var mainAccordionFontColor = "";
var subAccordionBackgroundColor = "";
var subAccordionFontColor = "";
var activeBadgeFontColor = "";
var activeBadgeBackgroundColor = "#FFFFFF"; // badge background stays white in both themes
var languageDropdownBackgroundColor = "";
var languageDropdownFontColor = "";
var darkModeVisibility = "";
var darkTheme = "";
var lightTheme = "";
var templateList1 = []; // has required accordion contents
var templateList2 = []; // has others accordion contents
var consentArray = {};
var consentArray2 = {};
var consentHandleId = "";
var tenantId = "";
var businessId = "";
var secureId = "";
let dotLoaderInterval; //loader constant
let initDotLoaderInterval;
var rowCheckboxes = [];
let currentSourceLang = "en";

function createToastContainer() {
  if (!document.getElementById("toast-container")) {
    const container = document.createElement("div");
    Object.assign(container.style, {
      position: "fixed",
      bottom: "1rem",
      left: "1rem",
      zIndex: "9999",
      display: "flex",
      flexDirection: "column-reverse",
      gap: "10px",
      alignItems: "flex-start", // ensures left alignment
    });
    container.id = "toast-container";
    document.body.appendChild(container);
  }
}

function showToast(message, type = "success", duration = 3000) {
  createToastContainer();

  const toast = document.createElement("div");
  Object.assign(toast.style, {
    display: "flex",
    alignItems: "center", // center vertically
    justifyContent: "space-between",
    gap: "10px",
    minWidth: "260px",
    maxWidth: "350px",
    padding: "12px 16px",
    borderRadius: "24px",
    backgroundColor: "rgba(0,0,0,0.65)",
    color: "#fff",
    fontFamily: fontFamily,
    fontSize: "14px",
    fontWeight: "500",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    opacity: "0",
    transform: "translateY(20px)",
    transition: "all 0.3s ease",
  });

  // Left icon
  const icon1 = document.createElement("span");
  icon1.innerHTML = `<svg width="25" height="25" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    ${
      type === "success"
        ? `<path d="M12 2a10 10 0 100 20 10 10 0 000-20zm5.21 7.71l-6 6a1.002 1.002 0 01-1.42 0l-3-3a1.003 1.003 0 111.42-1.42l2.29 2.3 5.29-5.3a1.004 1.004 0 011.42 1.42z" fill="#25AB21"></path>`
        : `<path d="M12 2a10 10 0 100 20 10 10 0 000-20zm3.71 12.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 13.41l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29-2.3-2.29a1.004 1.004 0 011.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42L13.41 12l2.3 2.29z" fill="#F50031"></path>`
    }
  </svg>`;
  Object.assign(icon1.style, {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  });

  // Message
  const msg = document.createElement("span");
  msg.innerText = message;
  Object.assign(msg.style, {
    flex: "1",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    wordBreak: "break-word",
  });

  // Close icon
  const closeBtn = document.createElement("span");
  closeBtn.innerHTML = `<svg width="25" height="25" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M13.41 12l6.3-6.29a1.004 1.004 0 00-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 10-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 000 1.42 1 1 0 001.42 0l6.29-6.3 6.29 6.3a1.001 1.001 0 001.639-.325 1 1 0 00-.22-1.095L13.41 12z" fill="currentColor"></path>
  </svg>`;
  Object.assign(closeBtn.style, {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    flexShrink: 0,
    color: "#fff",
  });
  closeBtn.onclick = () => toast.remove();

  // Append
  toast.appendChild(icon1);
  toast.appendChild(msg);
  toast.appendChild(closeBtn);
  document.getElementById("toast-container").appendChild(toast);

  // Animate in
  setTimeout(() => {
    toast.style.opacity = "1";
    toast.style.transform = "translateY(0)";
  }, 50);

  // Auto dismiss
  setTimeout(() => {
    toast.style.opacity = "0";
    toast.style.transform = "translateY(20px)";
    setTimeout(() => toast.remove(), 300);
  }, duration);
}

async function generateCodeChallenge(codeVerifier) {
  if (window.crypto && window.crypto.subtle) {
    // Use native secure API if available (HTTPS / localhost)
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
    const base64Hash = btoa(String.fromCharCode(...new Uint8Array(hashBuffer)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
    return base64Hash;
  } else {
    // 🔒 Fallback for HTTP: pure JS SHA-256 + Base64URL
    console.warn("crypto.subtle not available. Using fallback SHA-256.");

    function sha256(ascii) {
      const rightRotate = (value, amount) =>
        (value >>> amount) | (value << (32 - amount));

      let mathPow = Math.pow;
      let maxWord = mathPow(2, 32);
      let lengthProperty = "length";
      let i, j; // Used as a counter across the whole file
      let result = "";

      let words = [];
      let asciiBitLength = ascii[lengthProperty] * 8;

      let hash = (sha256.h = sha256.h || []);
      let k = (sha256.k = sha256.k || []);
      let primeCounter = k[lengthProperty];
      let isComposite = {};

      const fractionalPart = (n) => n - Math.floor(n);

      // Compute primes and hash constants
      function getPrime(n) {
        let num = 2;
        while (n > 0) {
          if (!isComposite[num]) {
            for (let i = num * num; i < 312; i += num) {
              isComposite[i] = true;
            }
            if (--n === 0) return num;
          }
          num++;
        }
      }

      if (!primeCounter) {
        let n = 0;
        let prime = 2;
        while (n < 64) {
          while (isComposite[prime]) prime++;
          hash[n] = (fractionalPart(Math.pow(prime, 1 / 2)) * maxWord) | 0;
          k[n++] = (fractionalPart(Math.pow(prime, 1 / 3)) * maxWord) | 0;
          for (i = prime * prime; i < 312; i += prime) {
            isComposite[i] = true;
          }
          prime++;
        }
      }

      ascii += "\x80"; // append '1' bit (plus zero padding)
      while ((ascii[lengthProperty] % 64) - 56) ascii += "\x00"; // pad until length ≡ 56 mod 64
      for (i = 0; i < ascii[lengthProperty]; i++) {
        j = ascii.charCodeAt(i);
        if (j >> 8) return; // ASCII check
        words[i >> 2] |= j << (((3 - i) % 4) * 8);
      }
      words[words[lengthProperty]] = (asciiBitLength / maxWord) | 0;
      words[words[lengthProperty]] = asciiBitLength;

      for (j = 0; j < words[lengthProperty]; ) {
        const w = words.slice(j, (j += 16));
        const oldHash = hash.slice(0);

        for (i = 16; i < 64; i++) {
          const s0 =
            rightRotate(w[i - 15], 7) ^
            rightRotate(w[i - 15], 18) ^
            (w[i - 15] >>> 3);
          const s1 =
            rightRotate(w[i - 2], 17) ^
            rightRotate(w[i - 2], 19) ^
            (w[i - 2] >>> 10);
          w[i] = (w[i - 16] + s0 + w[i - 7] + s1) | 0;
        }

        let a = hash[0],
          b = hash[1],
          c = hash[2],
          d = hash[3],
          e = hash[4],
          f = hash[5],
          g = hash[6],
          h = hash[7];

        for (i = 0; i < 64; i++) {
          const S1 =
            rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25);
          const ch = (e & f) ^ (~e & g);
          const temp1 = (h + S1 + ch + k[i] + w[i]) | 0;
          const S0 =
            rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22);
          const maj = (a & b) ^ (a & c) ^ (b & c);
          const temp2 = (S0 + maj) | 0;

          h = g;
          g = f;
          f = e;
          e = (d + temp1) | 0;
          d = c;
          c = b;
          b = a;
          a = (temp1 + temp2) | 0;
        }

        for (i = 0; i < 8; i++)
          hash[i] = (hash[i] + [a, b, c, d, e, f, g, h][i]) | 0;
      }

      for (i = 0; i < 8; i++) {
        for (j = 3; j + 1; j--) {
          const b = (hash[i] >> (j * 8)) & 255;
          result += (b < 16 ? "0" : "") + b.toString(16);
        }
      }
      return result;
    }

    function hexToBase64Url(hex) {
      let bytes = [];
      for (let c = 0; c < hex.length; c += 2) {
        bytes.push(parseInt(hex.substr(c, 2), 16));
      }
      let base64 = btoa(String.fromCharCode(...bytes));
      return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    }

    const hashHex = sha256(codeVerifier);
    return hexToBase64Url(hashHex);
  }
}

function startDigilockerFlow(consentArray) {
  showLoader();

  const responseType = "code";
  const codeChallengeMethod = "S256";

  generateDigilockerTransactionId(consentArray).then(async (consentMetaId) => {
    if (!consentMetaId) {
      hideLoader();
      return;
    }

    const state = consentMetaId;
    const state2 = `${state}:${secureId}`;
    const codeChallenge = await generateCodeChallenge(digilockercodeVerifier);

    const digilockerAuthUrl = `https://api.digitallocker.gov.in/public/oauth2/1/authorize?response_type=${responseType}&client_id=${digilockerClientId}&redirect_uri=${digilockerredirectUri}&code_challenge=${codeChallenge}&code_challenge_method=${codeChallengeMethod}&state=${state2}`;

    const newTab = window.open(digilockerAuthUrl, "_blank");

    const checkInterval = setInterval(() => {
      if (newTab.closed) {
        clearInterval(checkInterval);
        hideLoader();
        window.location.href = cburl;
      }
    }, 1000);
  });
}

function openUnder18Modal(consentArray) {
  let currentStep = 0;
  let selectedKYCMethod = null;
  let savedName = "";
  let savedIdentity = "";
  let savedDropdown = ""; // to preserve dropdown selection

  // Create overlay & box
  const modalOverlay = document.createElement("div");
  Object.assign(modalOverlay.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "9999",
  });

  const modalBox = document.createElement("div");
  Object.assign(modalBox.style, {
    borderRadius: "32px",
    width: "400px",
    padding: "20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
    position: "relative",
    background: cardBackgroundColor,
    color: cardFontColor,
  });

  // Header: back button + step text
  const headerRow = document.createElement("div");
  Object.assign(headerRow.style, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  });

  const backBtn = document.createElement("button");
  backBtn.innerHTML = "";
  Object.assign(backBtn.style, {
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    display: "none", // hidden on initial screen
  });

  const stepText = document.createElement("span");
  stepText.style.fontWeight = "600";
  stepText.style.fontFamily = fontFamily;
  stepText.style.fontSize = "16px";
  stepText.style.display = "none"; // hidden until Declaration is selected

  headerRow.appendChild(backBtn);
  headerRow.appendChild(stepText);

  // Title & content
  const title = document.createElement("div");
  Object.assign(title.style, {
    fontWeight: "500",
    fontSize: "14px",
    marginBottom: "5px",
    fontFamily: fontFamily,
  });

  const stepContent = document.createElement("div");

  // Footer (buttons)
  const footer = document.createElement("div");
  Object.assign(footer.style, {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "20px",
  });

  const cancelBtn = document.createElement("button");
  cancelBtn.innerText = window.modalTranslations?.cancel || "Cancel";
  Object.assign(cancelBtn.style, {
    background: btn1BackgroundColor,
    color: btn1FontColor,
    border: "1px solid rgba(181, 181, 181, 1)",
    padding: "8px 16px",
    borderRadius: "250px",
    fontWeight: "700",
    fontSize: "18px",
    fontFamily: fontFamily,
    cursor: "pointer",
  });

  const nextBtn = document.createElement("button");
  nextBtn.innerText = window.modalTranslations?.next || "Next";
  Object.assign(nextBtn.style, {
    background: btn2BackgroundColor,
    color: btn2FontColor,
    border: "1px solid rgba(181, 181, 181, 1)",
    padding: "8px 16px",
    borderRadius: "250px",
    fontWeight: "700",
    fontSize: "18px",
    fontFamily: fontFamily,
    cursor: "pointer",
  });

  footer.appendChild(cancelBtn);
  footer.appendChild(nextBtn);

  // Compose modal
  modalBox.appendChild(headerRow);
  modalBox.appendChild(title);
  modalBox.appendChild(stepContent);
  modalBox.appendChild(footer);
  modalOverlay.appendChild(modalBox);
  document.body.appendChild(modalOverlay);

  // Styled dropdown helper
  function createStyledDropdown(
    defaultOption = {
      label: "Select verification method",
      value: "",
    },
  ) {
    const container = document.createElement("div");
    Object.assign(container.style, {
      position: "relative",
      display: "flex",
      borderRadius: "20px",
      cursor: "pointer",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px",
    });

    const dropdown = document.createElement("select");
    Object.assign(dropdown.style, {
      padding: "9px 30px 9px 9px",
      fontSize: "14px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      cursor: "pointer",
      appearance: "none",
      width: "100%",
      color: "rgba(0,0,0,0.65)",
    });

    // Check if Digilocker data exists and is valid
    const hasDigilockerData =
      DigilockerData &&
      DigilockerData.searchList &&
      Array.isArray(DigilockerData.searchList) &&
      DigilockerData.searchList.length > 0;

    // Build options dynamically
    const options = [defaultOption];
    if (hasDigilockerData)
      options.push({
        label: "Proceed with KYC of the parent/legal guardian using DigiLocker",
        value: KYC_DIGILOCKER,
      });
    options.push({
      label:
        "Send the consent link to the parent/legal guardian over SMS/email and obtain approval",
      value: KYC_SMS,
    });

    // Add options to dropdown
    options.forEach((opt) => {
      const optionEl = document.createElement("option");
      optionEl.value = opt.value;
      optionEl.innerText = opt.label;
      dropdown.appendChild(optionEl);
    });

    if (savedDropdown) dropdown.value = savedDropdown;

    // Add SVG icon
    const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    icon.setAttribute("width", "20");
    icon.setAttribute("height", "20");
    icon.setAttribute("viewBox", "0 0 25 25");
    Object.assign(icon.style, {
      position: "absolute",
      top: "50%",
      right: "10px",
      transform: "translateY(-50%)",
      pointerEvents: "none",
    });
    icon.innerHTML = `<path d="M12 15a1 1 0 01-.71-.29l-4-4a1 1 0 111.42-1.42l3.29 3.3 3.29-3.3a1 1 0 111.42 1.42l-4 4A1 1 0 0112 15z" fill="currentColor"></path>`;

    dropdown.addEventListener("change", () => {
      selectedKYCMethod = dropdown.value;
      savedDropdown = dropdown.value;
    });

    container.appendChild(dropdown);
    container.appendChild(icon);
    return { container, select: dropdown };
  }

  // Validation helpers
  function isValidName(name) {
    return /^[a-zA-Z\s]+$/.test(name.trim());
  }
  function isValidIdentity(identity) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const mobileRegex = /^[0-9]{10}$/;
    return emailRegex.test(identity) || mobileRegex.test(identity);
  }

  // ----------- renderInitial (single screen that toggles inputs based on dropdown) -----------
  function renderInitial() {
    currentStep = 0;

    // Hide back button; stepText hidden until Declaration selected
    backBtn.style.display = "none";
    stepText.style.display = "none";
    headerRow.style.display = "flex"; // keep header area but stepText/back control visibility

    title.innerText =
      window.modalTranslations?.verificationMethod ||
      "Select verification method (Required)";
    stepContent.innerHTML = "";

    const { container, select } = createStyledDropdown();
    // restore saved selection
    if (savedDropdown) select.value = savedDropdown;

    // Parent name & identity (created once per initial render)
    const nameLabel = document.createElement("label");
    nameLabel.innerText =
      window.modalTranslations?.name || "Parent Name (Required)";
    Object.assign(nameLabel.style, {
      display: "none",
      marginBottom: "5px",
      fontWeight: "500",
      fontSize: "14px",
      fontFamily: fontFamily,
    });

    const nameInput = document.createElement("input");
    Object.assign(nameInput.style, {
      width: "100%",
      padding: "8px",
      marginBottom: "20px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      display: "none",
    });
    nameInput.value = savedName || "";

    const identityLabel = document.createElement("label");
    identityLabel.innerText =
      window.modalTranslations?.identity || "Identity (Email or Mobile)";
    Object.assign(identityLabel.style, {
      display: "none",
      marginBottom: "5px",
      fontWeight: "500",
      fontSize: "14px",
      fontFamily: fontFamily,
    });

    const identityInput = document.createElement("input");
    Object.assign(identityInput.style, {
      width: "100%",
      padding: "8px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      display: "none",
    });
    identityInput.value = savedIdentity || "";

    // append elements
    stepContent.appendChild(container);
    stepContent.appendChild(nameLabel);
    stepContent.appendChild(nameInput);
    stepContent.appendChild(identityLabel);
    stepContent.appendChild(identityInput);

    // Footer
    footer.innerHTML = "";
    footer.appendChild(cancelBtn);
    footer.appendChild(nextBtn);

    // helper to set visuals depending on selection
    function updateForSelection(val) {
      if (val === KYC_SMS) {
        // stepText.innerText = window.modalTranslations?.step1 || "Step 1/2";
        // stepText.style.display = "block";

        // show inputs
        nameLabel.style.display = "block";
        nameInput.style.display = "block";
        identityLabel.style.display = "block";
        identityInput.style.display = "block";

        backBtn.style.display = "none"; // NO back on initial screen
      } else {
        // blank or DIGILOCKER
        stepText.style.display = "none";

        nameLabel.style.display = "none";
        nameInput.style.display = "none";
        identityLabel.style.display = "none";
        identityInput.style.display = "none";

        backBtn.style.display = "none";
      }
    }

    // reflect saved selection
    updateForSelection(select.value);

    // change handler toggles inputs but does not show back button on initial
    select.addEventListener("change", () => {
      selectedKYCMethod = select.value;
      savedDropdown = select.value;
      updateForSelection(select.value);
    });

    // Next behaviour on this initial screen
    nextBtn.onclick = async () => {
      const sel = select.value;
      if (!sel) {
        showToast("Please select a verification method", "error");
        return;
      }

      if (sel === KYC_DIGILOCKER) {
        showLoader();
        modalOverlay.remove();
        overlay.remove();
        const responseType = "code";
        const codeChallengeMethod = "S256";

        // prepare redirect data
        const redirectData = {
          consentHandleId: consentHandleId,
          preferencesStatus: consentArray,
          languagePreference: finalSelectedLanguage,
        };

        const base64EncodedData = btoa(JSON.stringify(redirectData));
        // Step 1: Generate Transaction ID
        generateDigilockerTransactionId(consentArray).then(
          async (consentMetaId) => {
            if (!consentMetaId) {
              console.log("Transaction ID not received");
              return;
            }

            // Use consentMetaId as the `state`
            const state = consentMetaId;
            const state2 = `${state}:${secureId}`;

            const codeChallenge = await generateCodeChallenge(
              digilockercodeVerifier,
            );

            const digilockerAuthUrl = `https://api.digitallocker.gov.in/public/oauth2/1/authorize?response_type=${responseType}&client_id=${digilockerClientId}&redirect_uri=${digilockerredirectUri}&code_challenge=${codeChallenge}&code_challenge_method=${codeChallengeMethod}&state=${state2}`;

            setTimeout(() => {
              const newTab = window.open(digilockerAuthUrl, "_blank");

              const checkInterval = setInterval(() => {
                if (newTab.closed) {
                  clearInterval(checkInterval);
                  hideLoader();
                  window.location.href = cburl;
                }
              }, 1000);

              window.addEventListener("message", (event) => {
                if (event.data === "DIGILOCKER_DONE") {
                  hideLoader();
                  clearInterval(checkInterval);
                  window.location.href = cburl;
                }
              });
            }, 300);
          },
        );

        return;
      }

      window.addEventListener("load", async () => {
        try {
          const urlParams = new URLSearchParams(window.location.search);
          const encryptedData = urlParams.get("encryptedData");
          if (!encryptedData) throw new Error("Missing encrypted data");

          const decodedData = JSON.parse(atob(encryptedData));

          // Perform your backend or API actions
          await fetchDetails(decodedData);
          await callYourMethods(decodedData);

          //  Notify main tab and close
          if (window.opener) {
            s;
            window.opener.postMessage("DIGILOCKER_DONE", "*");
          }

          window.close();
        } catch (err) {
          console.log("Error in loader page:", err);
          window.close();
        }
      });

      if (sel === KYC_SMS) {
        const nameVal = nameInput.value.trim();
        const identityVal = identityInput.value.trim();

        if (!isValidName(nameVal)) {
          showToast("Name should contain letters only", "error");
          return;
        }
        if (!isValidIdentity(identityVal)) {
          showToast("Enter a valid email or 10-digit mobile", "error");
          return;
        }

        savedName = nameVal;
        savedIdentity = identityVal;

        // Call parental consent API
        const response = await sendParentalConsentRequest(nameVal, identityVal);
        if (response) {
          // Close the modal on success
          window.location.href = cburl;
          modalOverlay.remove();
          overlay.remove();
        }
      }
    };
  }

  // ----------- renderOTPStep (OTP screen with back button) -----------
  function renderOTPStep() {
    currentStep = 2;

    // show header, step 2/2 and back button
    headerRow.style.display = "flex";
    backBtn.style.display = "inline-flex";
    stepText.style.display = "block";
    stepText.innerText = window.modalTranslations?.step2 || "Step 2/2";

    title.innerText = "";
    stepContent.innerHTML = "";

    // build back arrow icon
    backBtn.innerHTML = "";
    const backIcon = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg",
    );
    backIcon.setAttribute("width", "24");
    backIcon.setAttribute("height", "24");
    backIcon.setAttribute("viewBox", "0 0 24 24");
    backIcon.innerHTML = `<path d="M15 20a1.003 1.003 0 01-.71-.29l-7-7a1 1 0 010-1.42l7-7a1.005 1.005 0 011.42 1.42L9.41 12l6.3 6.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z" fill="currentColor"></path>`;
    Object.assign(backIcon.style, {
      cursor: "pointer",
      fill: "rgba(0,0,0,0.75)",
    });
    backBtn.appendChild(backIcon);

    // OTP content
    const headerParentOTP = document.createElement("div");
    Object.assign(headerParentOTP.style, {
      fontWeight: "900",
      fontSize: "24px",
      marginBottom: "10px",
      fontFamily: fontFamily,
    });
    headerParentOTP.innerText =
      window.modalTranslations?.otpHeading || "OTP Verification";
    stepContent.appendChild(headerParentOTP);

    const instruction = document.createElement("div");
    instruction.innerText =
      window.modalTranslations?.otpInstruction ||
      "Enter the 6-digit OTP sent to 9800125683.";
    Object.assign(instruction.style, {
      fontSize: "14px",
      marginBottom: "20px",
      fontFamily: fontFamily,
      fontWeight: "500",
    });
    stepContent.appendChild(instruction);

    const otpInput = document.createElement("input");
    otpInput.type = "text";
    otpInput.maxLength = 6;
    otpInput.placeholder = "000000";
    Object.assign(otpInput.style, {
      width: "100%",
      height: "40px",
      textAlign: "center",
      fontSize: "18px",
      letterSpacing: "10px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      outline: "none",
      color: "#000",
      fontFamily: fontFamily,
      fontWeight: "500",
    });
    otpInput.addEventListener("input", (e) => {
      e.target.value = e.target.value.replace(/\D/g, "");
    });
    stepContent.appendChild(otpInput);

    // Footer: Verify only
    footer.innerHTML = "";
    const verifyBtn = document.createElement("button");
    verifyBtn.innerText = window.modalTranslations?.verify || "Verify";
    Object.assign(verifyBtn.style, {
      background: btn2BackgroundColor,
      color: btn2FontColor,
      border: "1px solid rgba(181, 181, 181, 1)",
      padding: "8px 16px",
      borderRadius: "250px",
      fontWeight: "700",
      fontSize: "18px",
      fontFamily: fontFamily,
      cursor: "pointer",
    });
    footer.appendChild(verifyBtn);

    // Back: return to initial state (restore saved values, no back button)
    backBtn.onclick = () => {
      // ensure saved values are preserved, then renderInitial which will restore visuals
      renderInitial();
      // after renderInitial executes, savedDropdown/name/identity are already used
    };

    verifyBtn.onclick = () => {
      const otp = otpInput.value.trim();
      if (otp.length !== 6) {
        showToast("Please enter a valid 6-digit OTP", "error");
        return;
      }
      showToast("OTP verified successfully!", "success");
      setTimeout(() => modalOverlay.remove(), 800);
    };
  }

  // cancel closes modal
  // cancelBtn.addEventListener("click", () => modalOverlay.remove());

  cancelBtn.addEventListener("click", () => {
    // Uncheck the checkbox
    if (checkbox) {
      checkbox.checked = false;
    }
    modalOverlay.remove();
    parentalFlow = false;
    checkbox2.checked = false;

    // Check all row checkboxes and update consentArray
    rowCheckboxes.forEach(({ checkbox, prefId }) => {
      checkbox.checked = false;
      // consentArray2[prefId] = "ACCEPTED";
    });
  });

  // start modal
  renderInitial();
}
function openParentalRelationModal(consentArray) {
  // Overlay
  const modalOverlay = document.createElement("div");
  Object.assign(modalOverlay.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "9999",
  });

  // Modal Box
  const modalBox = document.createElement("div");
  Object.assign(modalBox.style, {
    borderRadius: "24px",
    width: "420px",
    padding: "20px",
    background: cardBackgroundColor || "#fff",
    color: cardFontColor || "#000",
    position: "relative",
    fontFamily: fontFamily,
  });

  /* ---------------- Close Button ---------------- */
  const closeBtn = document.createElement("span");
  closeBtn.innerHTML = "&times;";
  Object.assign(closeBtn.style, {
    position: "absolute",
    top: "12px",
    right: "16px",
    fontSize: "22px",
    cursor: "pointer",
    fontWeight: "600",
  });

  function closeParentalModal() {
    hideLoader();

    modalOverlay.remove();
  }

  closeBtn.onclick = closeParentalModal;

  /* ---------------- Header Title ---------------- */
  const headerTitle = document.createElement("div");
  headerTitle.innerText =
    window.relationModalTranslation?.relation ||
    "Select your relationship with the child";
  Object.assign(headerTitle.style, {
    fontSize: "18px",
    fontWeight: "700",
    marginTop: "12px",
    marginBottom: "20px",
  });

  /* ---------------- Radio Options ---------------- */
  const optionsContainer = document.createElement("div");

  const createRadio = (translationKey, fallbackText, value) => {
    const wrapper = document.createElement("div");
    wrapper.style.marginBottom = "12px";

    const radio = document.createElement("input");
    radio.type = "radio";
    radio.name = "guardianType";
    radio.value = value;
    radio.style.marginRight = "8px";

    const label = document.createElement("label");

    label.innerText =
      window.relationModalTranslation?.[translationKey] || fallbackText;

    if (!window.relationModalElements) {
      window.relationModalElements = {};
    }
    window.relationModalElements[translationKey] = label;

    wrapper.appendChild(radio);
    wrapper.appendChild(label);

    return { wrapper, radio };
  };

  const parentOpt = createRadio("parent", "Parent", "PARENT");
  const guardianOpt = createRadio(
    "legalGuardian",
    "Legal Guardian",
    "LEGAL_GUARDIAN",
  );
  const otherOpt = createRadio("other", "Other", "OTHER");

  /* ---------------- Other Textbox ---------------- */
  const otherInputWrapper = document.createElement("div");
  Object.assign(otherInputWrapper.style, {
    marginLeft: "24px",
    marginTop: "8px",
    display: "none",
  });

  const otherInput = document.createElement("input");
  otherInput.type = "text";
  otherInput.placeholder = "Please specify relationship";
  Object.assign(otherInput.style, {
    width: "90%",
    padding: "6px 10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
  });

  otherInputWrapper.appendChild(otherInput);

  /* ---------------- Radio Behaviour ---------------- */
  otherOpt.radio.addEventListener("change", () => {
    otherInputWrapper.style.display = "block";
  });

  parentOpt.radio.addEventListener("change", () => {
    otherInputWrapper.style.display = "none";
    otherInput.value = "";
  });

  guardianOpt.radio.addEventListener("change", () => {
    otherInputWrapper.style.display = "none";
    otherInput.value = "";
  });

  optionsContainer.appendChild(parentOpt.wrapper);
  optionsContainer.appendChild(guardianOpt.wrapper);
  optionsContainer.appendChild(otherOpt.wrapper);
  optionsContainer.appendChild(otherInputWrapper);

  /* ---------------- Footer ---------------- */
  const footer = document.createElement("div");
  Object.assign(footer.style, {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "24px",
  });

  /* -------- Clear Button -------- */
  const clearBtn = document.createElement("button");
  clearBtn.innerText = window.relationModalTranslation?.clear || "Clear";
  Object.assign(clearBtn.style, {
    padding: "8px 18px",
    borderRadius: "24px",
    background: "#f0f0f0",
    color: "#333",
    fontSize: "14px",
    fontWeight: "600",
    border: "1px solid #ccc",
    cursor: "pointer",
  });

  clearBtn.onclick = () => {
    parentOpt.radio.checked = true;
    guardianOpt.radio.checked = false;
    otherOpt.radio.checked = false;
    otherInputWrapper.style.display = "none";
    otherInput.value = "";
  };

  /* -------- Save Button -------- */
  const relSaveBtn = document.createElement("button");
  relSaveBtn.innerText = window.relationModalTranslation?.save || "Save";
  Object.assign(relSaveBtn.style, {
    padding: "8px 20px",
    borderRadius: "24px",
    background: btn2BackgroundColor || "#007bff",
    color: btn2FontColor || "#fff",
    fontSize: "14px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
  });

  relSaveBtn.onclick = () => {
    const selected = document.querySelector(
      'input[name="guardianType"]:checked',
    );

    if (!selected) {
      showToast("Please select a relationship", "error", 3000);
      return;
    }

    if (selected.value === "OTHER" && !otherInput.value.trim()) {
      showToast("Please specify the relationship", "error", 3000);
      return;
    }

    window.selectedGuardianType = selected.value;
    window.otherGuardianText = otherInput.value || "";

    modalOverlay.remove();
    startDigilockerFlow(consentArray);
  };

  footer.appendChild(clearBtn);
  footer.appendChild(relSaveBtn);

  /* ---------------- Default Selection ---------------- */
  parentOpt.radio.checked = true;

  /* ---------------- Compose ---------------- */
  modalBox.appendChild(closeBtn);
  modalBox.appendChild(headerTitle);
  modalBox.appendChild(optionsContainer);
  modalBox.appendChild(footer);
  modalOverlay.appendChild(modalBox);
  document.body.appendChild(modalOverlay);
}

async function sendParentalConsentRequest(parentName, parentIdentity) {
  try {
    // Determine if identity is EMAIL or MOBILE
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isEmail = emailRegex.test(parentIdentity);
    const parentIdentityType = isEmail ? "EMAIL" : "MOBILE";

    showDotLoader("Sending consent request to parent");

    const url =
      "https://lua.consent.jiolabs.com/user/consent/v1.0/consent-handle/parental-consent";

    const response = await fetch(url, {
      method: "POST",
      headers: {
        accept: "*/*",
        txn: generateUUID(),
        "tenant-id": tenantId,
        "Content-Type": "application/json",
        "X-Secure-Code": secureId,
      },
      body: JSON.stringify({
        consentHandleId: consentHandleId,
        parentIdentity: parentIdentity.toUpperCase(),
        parentIdentityType: parentIdentityType,
        isParental: true,
        parentName: parentName,
        redirectUri: cburl,
      }),
    });

    const responseData = await response.json();

    if (!response.ok) {
      let message = "Failed to send parental consent request";

      if (responseData?.[0]?.errorMessage) {
        message = responseData[0].errorMessage;
      } else if (responseData?.message) {
        message = responseData.message;
      }

      showToast(message, "error", 3000);
      hideDotLoader();
      return null;
    }

    hideDotLoader();

    // Show appropriate message based on email or mobile
    const successMessage = isEmail
      ? "A consent request has been sent to your parent's email. Please ask them to approve it."
      : "A consent request has been sent to your parent's mobile. Please ask them to approve it.";

    showToast(successMessage, "success", 5000);

    return responseData;
  } catch (error) {
    hideDotLoader();
    console.log("Error in sendParentalConsentRequest:", error);
    showToast("Something went wrong. Please try again.", "error", 3000);
    return null;
  }
}

async function fetchDocument(doc_id) {
  try {
    const url = `https://lua.consent.jiolabs.com/user/consent/v1.0/documents/view-document/${doc_id}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        txn: "7afd223d-56c7-4556-9b2c-3032a684bcbd",
        "tenant-id": tenantId,
        Accept: "*/*",
        "X-Secure-Code": secureId,
      },
    });

    if (!response.ok) {
      throw new Error("API call failed: " + response.status);
    }

    const blob = await response.blob();

    const pdfUrl = URL.createObjectURL(blob);
    return pdfUrl;
  } catch (error) {
    console.log("Error fetching:", error);
    return null;
  }
}

const showDotLoader = (text) => {
  const overlay = document.createElement("div");
  overlay.id = "dot-loader-overlay";
  Object.assign(overlay.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1000",
    color: "rgb(15, 60, 201)",
    fontFamily: fontFamily,
    fontSize: "20px",
    fontWeight: "600",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
  });

  // text element
  const loaderText = document.createElement("div");
  loaderText.id = "dot-loader-text";
  loaderText.innerText = text;
  overlay.appendChild(loaderText);

  document.body.appendChild(overlay);

  // animate dots
  let dotCount = 0;
  dotLoaderInterval = setInterval(() => {
    dotCount = (dotCount + 1) % 5; // cycles 0..4
    loaderText.innerText = text + ".".repeat(dotCount);
  }, 500);
};

const showDotInitLoader = (text) => {
  const overlay = document.createElement("div");
  overlay.id = "init-dot-loader-overlay";
  Object.assign(overlay.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.05)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1000",
    color: "rgb(15, 60, 201)",
    fontFamily: fontFamily,
    fontSize: "20px",
    fontWeight: "600",

    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
  });

  // text element
  const loaderText = document.createElement("div");
  loaderText.id = "dot-loader-text";
  loaderText.innerText = text;
  overlay.appendChild(loaderText);

  document.body.appendChild(overlay);

  // animate dots
  let dotCount = 0;
  initDotLoaderInterval = setInterval(() => {
    dotCount = (dotCount + 1) % 5; // cycles 0..4
    loaderText.innerText = text + ".".repeat(dotCount);
  }, 500);
};

const hideDotLoader = () => {
  clearInterval(dotLoaderInterval);
  document.getElementById("dot-loader-overlay")?.remove();
};

const hideInitDotLoader = () => {
  clearInterval(initDotLoaderInterval);
  document.getElementById("init-dot-loader-overlay")?.remove();
};

async function callBhashini(selectedLangKey) {
  try {
    if (langFlag == 1) {
      showDotInitLoader("Loading");
      langFlag = 0;
    } else {
      showDotLoader("Translating");
    }
    const url = "https://lua.consent.jiolabs.com/user/translator/translate";
    const options = [
      { value: "ENGLISH", label: "English", apiValue: "en" },
      { value: "HINDI", label: "Hindi", apiValue: "hi" },
      { value: "BENGALI", label: "Bengali", apiValue: "bn" },
      { value: "TAMIL", label: "Tamil", apiValue: "ta" },
      { value: "TELUGU", label: "Telugu", apiValue: "te" },
      { value: "KANNADA", label: "Kannada", apiValue: "kn" },
      { value: "MALAYALAM", label: "Malayalam", apiValue: "ml" },
      { value: "GUJARATI", label: "Gujarati", apiValue: "gu" },
      { value: "MARATHI", label: "Marathi", apiValue: "mr" },
      { value: "ODIA", label: "Odia", apiValue: "or" },
      { value: "PUNJABI", label: "Punjabi", apiValue: "pa" },
      { value: "ASSAMESE", label: "Assamese", apiValue: "as" },
      { value: "NEPALI", label: "Nepali", apiValue: "ne" },
      { value: "SINDHI", label: "Sindhi", apiValue: "sd" },
      { value: "KASHMIRI", label: "Kashmiri", apiValue: "ks" },
      { value: "DOGRI", label: "Dogri", apiValue: "doi" },
      { value: "KONKANI", label: "Konkani", apiValue: "gom" },
      { value: "MAITHILI", label: "Maithili", apiValue: "mai" },
      { value: "SANSKRIT", label: "Sanskrit", apiValue: "sa" },
      { value: "SANTALI", label: "Santali", apiValue: "sat" },
      { value: "BODO", label: "Bodo", apiValue: "brx" },
      { value: "MANIPURI", label: "Manipuri", apiValue: "mni" },
    ];

    const selectedOption = options.find((opt) => opt.value === selectedLangKey);
    const targetLang = selectedOption ? selectedOption.apiValue : "";
    const targetLang2 = selectedOption ? selectedOption.value : "";
    finalSelectedLanguage = targetLang2;

    function toText(value) {
      return Array.isArray(value) ? value.join(", ") : value;
    }

    const dynamicInputs = templateList1.flatMap((item, index) => {
      const reqNo = index + 1;
      const inputs = [];

      // Translate Purpose, Duration, Id
      inputs.push({ id: `purpose_req_${reqNo}`, source: toText(item.Purpose) });
      inputs.push({
        id: `duration_req_${reqNo}`,
        source: toText(item.Duration),
      });
      inputs.push({ id: `id_req_${reqNo}`, source: item.Id });

      // Translate each Processing activity
      (item["Processing activity"] || []).forEach((activityObj, actIndex) => {
        inputs.push({
          id: `processingName_req_${reqNo}_${actIndex}`,
          source: activityObj.activityName,
        });
        inputs.push({
          id: `usedBy_req_${reqNo}_${actIndex}`,
          source: activityObj.processorName,
        });
        inputs.push({
          id: `dataType_req_${reqNo}_${actIndex}`,
          source: toText(activityObj.dataTypes),
        });
        inputs.push({
          id: `dataItem_req_${reqNo}_${actIndex}`,
          source: toText(activityObj.dataItems),
        });
      });

      return inputs;
    });

    const dynamicInputs2 = templateList2.flatMap((item, index) => {
      const reqNo = index + 1;
      const inputs = [];

      // Purpose, Duration, Id
      inputs.push({ id: `purpose_otr_${reqNo}`, source: toText(item.Purpose) });
      inputs.push({
        id: `duration_otr_${reqNo}`,
        source: toText(item.Duration),
      });
      inputs.push({ id: `id_otr_${reqNo}`, source: item.Id });

      // Each Processing activity
      (item["Processing activity"] || []).forEach((activityObj, actIndex) => {
        inputs.push({
          id: `processingName_otr_${reqNo}_${actIndex}`,
          source: activityObj.activityName,
        });
        inputs.push({
          id: `usedBy_otr_${reqNo}_${actIndex}`,
          source: activityObj.processorName,
        });
        inputs.push({
          id: `dataType_otr_${reqNo}_${actIndex}`,
          source: toText(activityObj.dataTypes),
        });
        inputs.push({
          id: `dataItem_otr_${reqNo}_${actIndex}`,
          source: toText(activityObj.dataItems),
        });
      });

      return inputs;
    });

    const staticInputs = [
      { id: "topDescription", source: topDesc },
      { id: "permissionDescription", source: permissionText },
      { id: "rightsDescription", source: rightsDesc },
      { id: "parentCheck", source: "I am below 18 years of age." },
      { id: "saveChoice", source: "Save My Choices" },
      { id: "allowAll", source: "Allow All" },
      { id: "badge", source: "Always Active" },
      { id: "requiredHeader", source: requiredLabel },
      { id: "othersHeader", source: "Others" },
      { id: "customerId", source: translatedLabel },
      { id: "header", source: "Manage Consent" },
      { id: "documentTitle", source: doc_name },
      { id: "click", source: "click here" },

      {
        id: "parentVerificationMethod",
        source: "Select verification method (Required)",
      },
      { id: "parentCancel", source: "Cancel" },
      { id: "parentNext", source: "Next" },
      { id: "parentName", source: "Parent Name (Required)" },
      { id: "parentIdentity", source: "Identity (Email or Mobile)" },
      { id: "parentStep1", source: "Step1/2" },
      { id: "parentStep2", source: "Step2/2" },
      { id: "parentOTPHeading", source: "OTP Verification" },
      {
        id: "parentOTPInstruction",
        source: "Enter the 6-digit OTP sent to 9800125683.",
      },
      { id: "parentVerify", source: "Verify" },
      { id: "relation", source: "Select your relationship with the child" },
      { id: "parent", source: "Parent" },
      { id: "legalGuardian", source: "Legal Guardian" },
      { id: "other", source: "Other" },
      { id: "pleaseSpecify", source: "Please specify relationship" },
      { id: "clear", source: "Clear" },
      { id: "save", source: "Save" },

      // add label translations
      { id: "Purpose", source: "Purpose" },
      { id: "Data type", source: "Data type" },
      { id: "Data item", source: "Data item" },
      { id: "Processing activity", source: "Processing activity" },
      { id: "Used by", source: "Used by" },
      { id: "Duration", source: "Duration" },
      { id: "Id", source: "Id" },
    ];

    const finalInputs = [...staticInputs, ...dynamicInputs, ...dynamicInputs2];

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        tenantid: tenantId,
        businessid: businessId,
        txn: generateUUID(),
        "X-Secure-Code": secureId,
      },
      body: JSON.stringify({
        configId: "e66b0624-61fb-44e9-b087-8bb312b5387b",
        provider: "BHASHINI",
        source: "CONSENTPOPUP",
        language: {
          sourceLanguage: currentSourceLang,
          targetLanguage: targetLang,
        },
        input: finalInputs,
      }),
    });

    const data2 = await response.json();

    // Build a map for translated labels

    const getTranslated = (id) =>
      data2.output.find((o) => o.id === id)?.target || "";

    // Build translatedTemplateList
    const translatedTemplateList = templateList1.map((item, index) => {
      const reqNo = index + 1;

      return {
        Purpose: [getTranslated(`purpose_req_${reqNo}`)],
        Duration: getTranslated(`duration_req_${reqNo}`),
        Id: item.Id,
        "Processing activity": (item["Processing activity"] || []).map(
          (act, actIndex) => ({
            activityName: getTranslated(
              `processingName_req_${reqNo}_${actIndex}`,
            ),
            processorName: getTranslated(`usedBy_req_${reqNo}_${actIndex}`),
            dataTypes: (
              getTranslated(`dataType_req_${reqNo}_${actIndex}`) || ""
            )
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean),
            dataItems: (
              getTranslated(`dataItem_req_${reqNo}_${actIndex}`) || ""
            )
              .split(",")
              .map((s) => s.trim()),
          }),
        ),
      };
    });

    // Build translatedTemplateList2
    const translatedTemplateList2 = templateList2.map((item, index) => {
      const reqNo = index + 1;

      const processingActivities = (item["Processing activity"] || []).map(
        (act, actIndex) => ({
          activityName: getTranslated(
            `processingName_otr_${reqNo}_${actIndex}`,
          ),
          processorName: getTranslated(`usedBy_otr_${reqNo}_${actIndex}`),
          dataTypes: (getTranslated(`dataType_otr_${reqNo}_${actIndex}`) || "")
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean),
          dataItems: (getTranslated(`dataItem_otr_${reqNo}_${actIndex}`) || "")
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean),
        }),
      );

      return {
        Purpose: [getTranslated(`purpose_otr_${reqNo}`)],
        Duration: getTranslated(`duration_otr_${reqNo}`),
        Id: item.Id,
        "Processing activity": processingActivities,
      };
    });

    [
      "Purpose",
      "Data type",
      "Data item",
      "Processing activity",
      "Used by",
      "Duration",
      "Id",
    ].forEach((key) => {
      const obj = data2.output.find((o) => o.id === key);
      keyTranslations[key] = obj ? obj.target : key;
    });

    function renderTranslatedList(list, container, keyTranslations) {
      if (!container) return;
      container.innerHTML = "";

      list.forEach((template) => {
        container.appendChild(
          buildPurposeAccordionItem(template, {
            keyTranslations,
            arrowColor: buttonBackgroundColor,
            cardColor: cardFontColor,
          }),
        );
      });
    }

    // Same change for renderTranslatedList2:
    function renderTranslatedList2(list, container, keyTranslations) {
      if (!container) return;
      container.innerHTML = "";
      rowCheckboxes = [];

      list.forEach((template) => {
        container.appendChild(
          buildPurposeAccordionItem(template, {
            keyTranslations,
            showCheckbox: true,
            preferenceId: template.Id,
            arrowColor: buttonBackgroundColor,
            cardColor: cardFontColor,
          }),
        );
      });
    }

    // Finally call with keyTranslations
    renderTranslatedList(translatedTemplateList, content, keyTranslations);
    renderTranslatedList2(translatedTemplateList2, content2, keyTranslations);

    const getTarget = (id) =>
      data2.output.find((o) => o.id === id)?.target || null;
    ConsentAllow.innerHTML =
      data?.multilingual?.languageSpecificContentMap?.[selectedLangKey]
        ?.permissionText || getTarget("permissionDescription");
    TopDesc.innerHTML =
      data?.multilingual?.languageSpecificContentMap?.[selectedLangKey]
        ?.description || getTarget("topDescription");
    withdrawLine.innerHTML =
      data?.multilingual?.languageSpecificContentMap?.[selectedLangKey]
        ?.rightsText || getTarget("rightsDescription");
    checkboxLabel.innerHTML = getTarget("parentCheck");
    title.innerText = getTarget("header");
    labelSpan.innerHTML = getTarget("customerId");
    badge.innerText = getTarget("badge");
    label.innerText = getTarget("requiredHeader");
    label2.innerText = getTarget("othersHeader");
    saveBtn.innerText = getTarget("saveChoice");
    allowBtn.innerText = getTarget("allowAll");
    documentLink.innerText = getTarget("documentTitle");
    clickHere.innerHTML = getTarget("click");

    currentSourceLang = targetLang;
    window.relationModalTranslation = {
      relation: getTarget("relation"),
      parent: getTarget("parent"),
      legalGuardian: getTarget("legalGuardian"),
      other: getTarget("other"),
      pleaseSpecify: getTarget("pleaseSpecify"),
      clear: getTarget("clear"),
      save: getTarget("save"),
    };
    window.modalTranslations = {
      verificationMethod: getTarget("parentVerificationMethod"),
      cancel: getTarget("parentCancel"),
      next: getTarget("parentNext"),
      name: getTarget("parentName"),
      identity: getTarget("parentIdentity"),
      step1: getTarget("parentStep1"),
      step2: getTarget("parentStep2"),
      otpHeading: getTarget("parentOTPHeading"),
      otpInstruction: getTarget("parentOTPInstruction"),
      verify: getTarget("parentVerify"),
    };
    hideDotLoader();
    hideInitDotLoader();
  } catch (error) {
    console.log("Translation error:", error);
    hideDotLoader();
    hideInitDotLoader();
  }
}

function applyRelationModalTranslations() {
  if (!window.relationModalElements) return;

  Object.keys(window.relationModalElements).forEach((key) => {
    const el = window.relationModalElements[key];
    const translatedText = window.relationModalTranslation?.[key];

    if (el && translatedText) {
      el.innerText = translatedText;
    }
  });
}

async function generateDigilockerTransactionId(consentArray) {
  if (
    consentArray == null ||
    (typeof consentArray === "object" && Object.keys(consentArray).length === 0)
  ) {
    rowCheckboxes.forEach(({ checkbox, prefId }) => {
      consentArray[prefId] = "NOTACCEPTED";
    });
  }

  try {
    showDotLoader("Capturing Your Consent");
    let relationshipValue = "parent";

    if (window.selectedGuardianType === "PARENT") {
      relationshipValue = "Parent";
    } else if (window.selectedGuardianType === "LEGAL_GUARDIAN") {
      relationshipValue = "Legal Guardian";
    } else if (window.selectedGuardianType === "OTHER") {
      relationshipValue = window.otherGuardianText || "";
    }
    const url =
      "https://lua.consent.jiolabs.com/user/consent/v1.0/consent-meta/create";
    console.log("RElationship Value:", relationshipValue);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        txn: generateUUID(),
        "Content-Type": "application/json",
        "tenant-id": tenantId,
        "X-Secure-Code": secureId,
      },
      body: JSON.stringify({
        consentHandleId: consentHandleId,
        preferencesStatus: consentArray,
        languagePreference: finalSelectedLanguage,
        isParentalConsent: true,
        secId: secureId,
        relation: relationshipValue,
      }),
    });

    const responseData = await response.json();

    if (!response.ok) {
      let message = "API call failed";

      if (responseData?.[0]?.errorCode === "JCMP3004") {
        message = "Consent Handle already exists";
      } else if (responseData?.[0]?.errorMessage) {
        message = responseData[0].errorMessage;
      }

      showToast(message, "error", 3000);
      throw new Error("API call failed: " + response.status);
    }

    //  Extract consentMetaId from response
    const consentMetaId = responseData?.consentMetaId;

    // if (consentMetaId) {
    //   showToast("Consent Successfully captured.", "success", 6000);
    // }

    overlay.remove();
    hideDotLoader();

    return consentMetaId;
  } catch (error) {
    hideDotLoader();
    console.log("Error in generateDigilockerTransactionId:", error);
    return null;
  }
}

async function captureConsent(consentArray) {
  if (
    consentArray == null || // covers null & undefined
    (typeof consentArray === "object" && Object.keys(consentArray).length === 0)
  ) {
    rowCheckboxes.forEach(({ checkbox, prefId }) => {
      consentArray[prefId] = "NOTACCEPTED";
    });
  }
  try {
    if (parentalFlow == true) {
      // If isParental is true, auto-trigger Digilocker flow directly
      if (isParental) {
        // showLoader();
        //overlay.remove();
        openParentalRelationModal(consentArray);

        return;
      }
      // Otherwise show the under 18 modal for manual selection
      openUnder18Modal(consentArray);
    } else {
      showDotLoader("Capturing Your Consent");
      const url =
        "https://lua.consent.jiolabs.com/user/consent/v1.0/consent/create";

      const response = await fetch(url, {
        method: "POST",
        headers: {
          txn: "7afd223d-56c7-4556-9b2c-3032a684bcbd",
          "tenant-id": tenantId,
          Accept: "*/*",
          "Content-Type": "application/json",
          "X-Secure-Code": secureId,
        },
        body: JSON.stringify({
          consentHandleId: consentHandleId,
          preferencesStatus: consentArray,
          languagePreference: finalSelectedLanguage,
        }),
      });

      if (!response.ok) {
        const responseData = await response.json();

        let message = "API call failed";

        if (responseData?.[0]?.errorCode === "JCMP3004") {
          message = "Consent Handle already exists";
        } else if (responseData?.[0]?.errorMessage) {
          message = responseData[0].errorMessage;
        }

        showToast(message, "error", 3000);
        throw new Error("API call failed: " + response.status);
      } else {
        showToast("Consent Successfully captured.", "success", 6000);
        parentalFlow = false;
        overlay.remove();
        hideDotLoader();
        window.location.href = cburl;
      }
    }
  } catch (error) {
    return null;
  }
}

async function captureAllConsent(consentArray) {
  try {
    if (parentalFlow == true) {
      // If isParental is true, auto-trigger Digilocker flow directly
      if (isParental) {
        // showLoader();
        //overlay.remove();
        openParentalRelationModal(consentArray);

        return;
      }
      // Otherwise show the under 18 modal for manual selection
      openUnder18Modal(consentArray);
    } else {
      showDotLoader("Capturing Your Consent");
      const url =
        "https://lua.consent.jiolabs.com/user/consent/v1.0/consent/create";

      const response = await fetch(url, {
        method: "POST",
        headers: {
          txn: "7afd223d-56c7-4556-9b2c-3032a684bcbd",
          "tenant-id": tenantId,
          Accept: "*/*",
          "Content-Type": "application/json",
          "X-Secure-Code": secureId,
        },
        body: JSON.stringify({
          consentHandleId: consentHandleId,
          preferencesStatus: consentArray,
          languagePreference: finalSelectedLanguage,
        }),
      });

      if (!response.ok) {
        const responseData = await response.json();

        let message = "API call failed";

        if (responseData?.[0]?.errorCode === "JCMP3004") {
          message = "Consent Handle already exists";
        } else if (responseData?.[0]?.errorMessage) {
          message = responseData[0].errorMessage;
        }

        showToast(message, "error", 3000);
        throw new Error("API call failed: " + response.status);
      } else {
        showToast("Consent Successfully captured.", "success", 3000);
        // window.location.href = "/loggedIn";
        parentalFlow = false;
        window.location.href = cburl;
        overlay.remove();
        hideDotLoader();
      }
    }
  } catch (error) {
    hideDotLoader();
    return null;
  }
}

async function fetchConsentData() {
  try {
    const url = `https://lua.consent.jiolabs.com/user/consent/v1.0/consent-handle/get/${consentHandleId}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        txn: "7afd223d-56c7-4556-9b2c-3032a684bcbd",
        "tenant-id": tenantId,
        Accept: "*/*",
        "X-Secure-Code": secureId,
      },
    });

    if (!response.ok) {
      throw new Error("API call failed: " + response.status);
    }

    data = await response.json();

    // Extract parental consent fields
    isParental = data?.isParental || false;
    parentIdentity = data?.parentIdentity || "";
    parentIdentityType = data?.parentIdentityType || "";
    parentName = data?.parentName || "";

    // Use parentIdentity as customer ID if isParental is true
    cusId = isParental ? parentIdentity : data?.customerIdentifiers?.value;

    if (data?.multilingual?.supportedLanguages.length == 1) {
      langRecieved = data?.multilingual?.supportedLanguages[0];
      langFlag = 1;
    }

    doc_name = data?.documentMeta?.name;
    doc_id = data?.documentMeta?.documentId;
    topDesc =
      data?.multilingual?.languageSpecificContentMap?.ENGLISH?.description;
    rightsDesc =
      data?.multilingual?.languageSpecificContentMap?.ENGLISH?.rightsText;
    permissionText =
      data?.multilingual?.languageSpecificContentMap?.ENGLISH?.permissionText;
    requiredLabel =
      data?.multilingual?.languageSpecificContentMap?.ENGLISH?.label;
    parentalControl = data?.uiConfig?.parentalControl;
    dataItemToBeShown = data?.uiConfig?.dataItemToBeShown;
    processActivityNameToBeShown = data?.uiConfig?.processActivityNameToBeShown;
    processorNameToBeShown = data?.uiConfig?.processorNameToBeShown;
    validitytoBeShown = data?.uiConfig?.validitytoBeShown;
    darkModeVisibility = data?.uiConfig?.darkMode;
    // darkModeVisibility = false;
    // parentalControl = true;
    logoUrl = data?.uiConfig?.logo;

    // Typography configured for the tenant. The base64 font file is registered
    // as "DynamicFont"; system-ui stays as the fallback while it loads or when
    // no font file is configured.
    const typography = data?.uiConfig?.typographySettings?.ENGLISH;

    if (typography) {
      fontStyle = typography?.fontStyle || fontStyle;

      if (typography?.fontFile) {
        const font = new FontFace(
          "DynamicFont",
          `url(data:application/octet-stream;base64,${typography.fontFile})`,
        );

        font.load().then(function (loadedFont) {
          document.fonts.add(loadedFont);
        });

        fontFamily = "DynamicFont, system-ui";
      }
    }

    var theme = data?.uiConfig?.theme;

    if (theme) {
      var decodedThemeStr = atob(theme);

      var decodedTheme = JSON.parse(decodedThemeStr);

      lightTheme = JSON.parse(decodedTheme.light);
      darkTheme = JSON.parse(decodedTheme.dark);

      cardBackgroundColor = lightTheme.cardBackground;
      cardFontColor = lightTheme.cardFont;
      buttonBackgroundColor = lightTheme.buttonBackground;
      buttonFontColor = lightTheme.buttonFont;
      linkFontColor = lightTheme.linkFont;
      btn1BackgroundColor = lightTheme.buttonFont;
      btn1FontColor = lightTheme.buttonBackground;
      btn2BackgroundColor = lightTheme.buttonBackground;
      btn2FontColor = lightTheme.buttonFont;
      applyThemeTokens(lightTheme);
    }

    data?.preferences?.forEach((pref) => {
      const puporse = (pref.purposeList || [])
        .map((pa) => pa.purposeInfo?.purposeName)
        .filter(Boolean);

      const usedBy = pref.processorActivityList.map(
        (pa) => pa.processActivityInfo.processorName,
      );

      const processingActivities = pref.processorActivityList.map((p) => ({
        activityName: p.processActivityInfo.activityName,

        processorName: p.processActivityInfo.processorName,

        // Every data type of the activity clubbed into one row, same for items
        dataTypes: [
          ...new Set(
            p.processActivityInfo.dataTypesList
              .map((d) => d.dataTypeName)
              .filter(Boolean),
          ),
        ],

        dataItems: p.processActivityInfo.dataTypesList.flatMap(
          (d) => d.dataItems,
        ),
      }));
      const dataItems = pref.processorActivityList.flatMap((pa) =>
        pa.processActivityInfo.dataTypesList.flatMap((dt) => dt.dataItems),
      );

      const id = pref.preferenceId;

      const obj = {
        Purpose: puporse,
        "Used by": [...new Set(usedBy)],
        Duration: `${pref.preferenceValidity.value} ${
          pref.preferenceValidity.value === 1
            ? pref.preferenceValidity.unit.replace(/s$/i, "") // remove trailing s
            : pref.preferenceValidity.unit
        }`,

        "Processing activity": processingActivities,
        "Data item": dataItems,
        Id: id,
      };

      consentArray2[pref.preferenceId] = "ACCEPTED";
      if (pref.mandatory) {
        templateList1.push(obj); // Required
        consentArray[pref.preferenceId] = "ACCEPTED";
      } else {
        templateList2.push(obj); // Other
      }
    });
    return data;
  } catch (error) {
    console.log("Error fetching:", error);
    return null;
  }
}

async function fetchDigilockerData() {
  try {
    const url = `https://lua.consent.jiolabs.com/user/partnerportal/v1.0/digilocker/credential/search`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        txn: generateUUID(),
        "tenant-id": tenantId,
        "x-session-token":
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJwYXJ0bmVyLXBvcnRhbCIsInRlbmFudElkIjoiNTg5Yzk1YzYtNGJiOC00Njc4LThjMGItYzE1YzczNmNiNDZkIiwic3ViIjoiMzA1NWEwNDItOTFkZi00MWI2LWIxZDMtNDc2YWM5M2ZiNGM2IiwiZXhwIjoxNzYxODg4ODc4LCJpYXQiOjE3NjE4ODUyNzh9.bLREZVmrQrIwxxvIj0BjFmfa9wUiwtbu9GqXmQcmfaznl8UMAuhFq3OEVEKC4wXTh6Ahk_2uwUs0_EmN_wtBc2gVmrZ7tESijFTUPlelzm3NExFXfMR6HcfQxyyvkcZh9Ih_JqEgpJG0akQDdjK0tUd--usZMhFz069T-h5PavvCl6hODDxCwNEtJCWWo0RJ3YEkj6JTjvSRkbIvFULjrA8Qd0uj_31UswcKWheInajoNG-rhEwYO62hpbxFw7svJFDd4whY5JtfXWSV5jC1l1-zy5HaFYn8_q9Euf-S7FP6zCICqGQ7cIK5bgstJhV2QsvdZE6SpRnuabRznzkucg",
        Accept: "application/json",
        "X-Secure-Code": secureId,
      },
    });

    if (!response.ok) {
      throw new Error("API call failed: " + response.status);
    }
    const data2 = await response.json();
    return data2;
  } catch (error) {
    console.log("Error fetching:", error);
    return null;
  }
}

function changeDesc(selectedLangKey) {
  callBhashini(selectedLangKey).then(() => {
    applyRelationModalTranslations();
  });
}

function selectKYCMethod(method) {
  console.log("Yesssssss", method);
}

const showLoader = () => {
  const overlay = document.createElement("div");
  overlay.id = "loader-overlay";
  Object.assign(overlay.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1000",
  });

  // spinner container
  const spinner = document.createElement("div");
  Object.assign(spinner.style, {
    border: "8px solid #f3f3f3",
    borderTop: "8px solid #3498db",
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    animation: "spin 1s linear infinite",
  });

  // inject keyframes if not already added
  if (!document.getElementById("loader-style")) {
    const style = document.createElement("style");
    style.id = "loader-style";
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  overlay.appendChild(spinner);
  document.body.appendChild(overlay);
};

const hideLoader = () => {
  console.log("Callleddd..");
  document.getElementById("loader-overlay")?.remove();
};

function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

async function callBhashiniConfig(tenant, business) {
  try {
    const url =
      "https://lua.consent.jiolabs.com/user/translator/translateConfig";

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        tenantid: tenant,
        businessid: tenant,
        txn: generateUUID(),
        "X-Secure-Code": secureId,
      },
      body: JSON.stringify({
        scopeLevel: "BUSINESS",
        config: {
          provider: "BHASHINI",
          apiBaseUrl: "https://meity-auth.ulcacontrib.org",
          modelPipelineEndpoint: "/ulca/apis/v0/model/getModelsPipeline",
          callbackUrl:
            "https://dhruva-api.bhashini.gov.in/services/inference/pipeline",
          userId: "02c3fec39bbf46cda8ece45ba52e78cb",
          apiKey: "058a0399da-ea84-4077-9e3e-984ff46f8b77",
          pipelineId: "64392f96daac500b55c543cd",
        },
      }),
    });

    if (!response.ok) {
      console.log("Bhashini config API call failed:", response.status);
      return null;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.log("Error calling Bhashini config API:", error);
    return null;
  }
}

const loadPreferenceCenter = async (
  handleId,
  tenant,
  business,
  cbackUrl,
  secCode,
) => {
  consentHandleId = handleId;
  tenantId = tenant;
  businessId = business;
  secureId = secCode;
  cburl = cbackUrl;
  showLoader();
  // Call Bhashini configuration API first
  await callBhashiniConfig(tenant, business);

  const consentData = await fetchConsentData();
  console.log("Consent Data recieved:", consentData);
  if (consentData == null || consentData == undefined) {
    showToast("Something went wrong. Please try again later.", "error", 5000);
    setTimeout(() => {
      window.location.replace(cburl);
    }, 3000);
  } else {
    DigilockerData = await fetchDigilockerData();

    if (consentData?.documentMeta?.documentId) {
      await fetchDocument(consentData.documentMeta.documentId);
    }
    // callBhashiniConfig(tenant, business);

    if (DigilockerData) {
      digilockerClientId = DigilockerData?.searchList[0]?.clientId;
      digilockerSecret = DigilockerData?.searchList[0]?.clientSecret;
      digilockercodeVerifier = DigilockerData?.searchList[0]?.codeVerifier;
      digilockerredirectUri = DigilockerData?.searchList[0]?.redirectUri;
    }
    //hideLoader();
    createIntegrationPopup();
    callBhashini(langRecieved);
  }
};

// Pulls the accordion / badge / language-dropdown colours out of a decoded
// theme block (light or dark). Falls back to the card colours so tenants whose
// theme does not carry the newer keys keep rendering as before.
function applyThemeTokens(themeObj) {
  if (!themeObj) return;

  mainAccordionBackgroundColor =
    themeObj.mainAccordionBackground || themeObj.cardBackground;
  mainAccordionFontColor = themeObj.mainAccordionFont || themeObj.cardFont;
  subAccordionBackgroundColor =
    themeObj.subAccordionBackground || themeObj.cardBackground;
  subAccordionFontColor = themeObj.subAccordionFont || themeObj.cardFont;
  activeBadgeFontColor = themeObj.activeBadgeFont || themeObj.cardFont;
  languageDropdownBackgroundColor =
    themeObj.languageDropdownBackground || themeObj.cardBackground;
  languageDropdownFontColor =
    themeObj.languageDropdownFont || themeObj.cardFont;
}

// Repaints the purpose (sub) accordion headings that are already on screen.
// They are rebuilt on every language change, so new ones pick the colours up
// at creation time and this only has to cover the existing ones.
function applySubAccordionTheme() {
  document
    .querySelectorAll(".purpose-nested-accordion__summary")
    .forEach((el) => {
      el.style.background = subAccordionBackgroundColor;
      el.style.color = subAccordionFontColor;
    });
}

// The purpose detail rows carry an inline colour set when they were built, so
// inheriting from the container is not enough - repaint them with the card
// font of whichever theme is now active.
function applySubAccordionBodyTheme() {
  document.querySelectorAll(".purpose-nested-accordion__body").forEach((el) => {
    el.style.color = cardFontColor;
  });
}

function buildPurposeAccordionItem(template, options = {}) {
  const {
    keyTranslations,
    showCheckbox = false,
    preferenceId = null,
    arrowColor = "",
    cardColor = "",
    syncMasterCheckbox = false,
  } = options;

  const details = document.createElement("details");
  details.className = "purpose-nested-accordion";

  const summary = document.createElement("summary");
  summary.className = "purpose-nested-accordion__summary";
  // Purpose heading colours come from the theme's subAccordion tokens
  summary.style.background = subAccordionBackgroundColor;
  summary.style.color = subAccordionFontColor;

  const arrowEl = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  arrowEl.setAttribute("width", "30");
  arrowEl.setAttribute("height", "30");
  arrowEl.setAttribute("viewBox", "5 0 12 23");
  arrowEl.classList.add("purpose-nested-accordion__arrow");
  arrowEl.style.color = arrowColor;
  arrowEl.innerHTML = `<path d="M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z" fill="currentColor"></path>`;

  const titleSpan = document.createElement("span");
  titleSpan.className = "purpose-nested-accordion__title";

  const purposes = Array.isArray(template.Purpose)
    ? template.Purpose.join(", ")
    : template.Purpose || "";

  const labelSpan = document.createElement("span");
  labelSpan.className = "purpose-label";
  labelSpan.textContent = "";

  const valueSpan = document.createElement("span");
  valueSpan.className = "purpose-value";
  valueSpan.textContent = purposes;

  titleSpan.appendChild(labelSpan);
  titleSpan.appendChild(valueSpan);
  summary.appendChild(arrowEl);
  summary.appendChild(titleSpan);

  if (showCheckbox && preferenceId) {
    const checkboxDiv = document.createElement("div");
    checkboxDiv.className = "purpose-nested-accordion__checkbox";

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.className = "purpose-nested-accordion__input";
    checkbox.style.accentColor = buttonBackgroundColor;

    if (consentArray[preferenceId]) checkbox.checked = true;

    checkbox.addEventListener("click", (e) => e.stopPropagation());
    checkbox.addEventListener("change", () => {
      if (checkbox.checked) consentArray[preferenceId] = "ACCEPTED";
      else delete consentArray[preferenceId];

      if (syncMasterCheckbox && typeof checkbox2 !== "undefined") {
        checkbox2.checked = rowCheckboxes.every(
          ({ checkbox: rowCheckbox }) => rowCheckbox.checked,
        );
      }
    });

    checkboxDiv.appendChild(checkbox);
    summary.appendChild(checkboxDiv);
    rowCheckboxes.push({ checkbox, prefId: preferenceId });
  } else {
    const checkboxDiv = document.createElement("div");
    checkboxDiv.className = "purpose-nested-accordion__checkbox";

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.className = "purpose-nested-accordion__input";
    checkbox.checked = true;
    checkbox.disabled = true;
    checkbox.style.accentColor = buttonBackgroundColor;
    checkbox.style.cursor = "not-allowed";

    checkbox.addEventListener("click", (e) => e.stopPropagation());

    checkboxDiv.appendChild(checkbox);
    summary.appendChild(checkboxDiv);
  }

  const body = document.createElement("div");
  body.className = "purpose-nested-accordion__body";
  if (cardColor) {
    body.style.color = cardColor;
  }

  function addBodyRow(label, value) {
    const rowDiv = document.createElement("div");
    rowDiv.className = "consent-detail-row";

    const rowLabel = document.createElement("span");
    rowLabel.className = "consent-label";
    rowLabel.textContent = `${label} `;

    const rowValue = document.createElement("span");
    rowValue.className = "consent-value";
    rowValue.textContent = value;

    rowDiv.appendChild(rowLabel);
    rowDiv.appendChild(rowValue);
    body.appendChild(rowDiv);
  }

  if (validitytoBeShown) {
    addBodyRow(`${keyTranslations["Duration"]}:`, template.Duration);
  }

  const processingActivities = template["Processing activity"] || [];
  const hasProcessingRows =
    processingActivities.length > 0 &&
    (processActivityNameToBeShown ||
      processorNameToBeShown ||
      dataItemToBeShown);

  if (hasProcessingRows) {
    const hrMain = document.createElement("hr");
    body.appendChild(hrMain);
  }

  processingActivities.forEach((activityObj, aIndex) => {
    if (processActivityNameToBeShown) {
      addBodyRow(
        `${keyTranslations["Processing activity"]}:`,
        activityObj.activityName,
      );
    }
    if (processorNameToBeShown) {
      addBodyRow(`${keyTranslations["Used by"]}:`, activityObj.processorName);
    }
    if (dataItemToBeShown) {
      const dataTypes = Array.isArray(activityObj.dataTypes)
        ? activityObj.dataTypes.filter(Boolean)
        : activityObj.dataTypes;

      if (Array.isArray(dataTypes) ? dataTypes.length : dataTypes) {
        addBodyRow(
          `${keyTranslations["Data type"]}:`,
          Array.isArray(dataTypes) ? dataTypes.join(", ") : dataTypes,
        );
      }

      addBodyRow(
        `${keyTranslations["Data item"]}:`,
        Array.isArray(activityObj.dataItems)
          ? activityObj.dataItems.join(", ")
          : activityObj.dataItems,
      );
    }

    if (
      !(
        dataItemToBeShown === false &&
        processActivityNameToBeShown === false &&
        processorNameToBeShown === false
      ) &&
      aIndex < processingActivities.length - 1
    ) {
      const hrActivity = document.createElement("hr");
      body.appendChild(hrActivity);
    }
  });

  details.appendChild(summary);
  details.appendChild(body);
  return details;
}

const createIntegrationPopup = () => {
  overlay = document.createElement("div");
  Object.assign(overlay.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1000",
  });

  const modal = document.createElement("div");
  Object.assign(modal.style, {
    background: cardBackgroundColor,
    padding: "20px",
    borderRadius: "32px",
    width: "584px",
    textAlign: "left",
    fontFamily: fontFamily,
    fontStyle: fontStyle,
    //maxHeight: "90vh",
    // overflowY: "auto",
    boxSizing: "border-box",
    // ScrollBarWidth: "none",
    color: cardFontColor,
  });
  modal.classList.add("custom-modal");

  const toggleWrapper = document.createElement("label");
  Object.assign(toggleWrapper.style, {
    position: "fixed",
    top: "0.5rem",
    right: "0.5rem",
    display: "inline-block",
    width: "50px",
    height: "28px",
    zIndex: "1100",
    cursor: "pointer",
  });

  // Create hidden checkbox
  const toggleCheckbox = document.createElement("input");
  toggleCheckbox.type = "checkbox";
  Object.assign(toggleCheckbox.style, {
    opacity: "0",
    width: "0",
    height: "0",
  });

  // Create slider span
  const slider = document.createElement("span");
  Object.assign(slider.style, {
    position: "absolute",
    cursor: "pointer",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "#ccc",
    transition: "0.3s",
    borderRadius: "34px",
  });

  // Add circle inside slider
  const circle = document.createElement("span");
  Object.assign(circle.style, {
    position: "absolute",
    content: '""',
    height: "22px",
    width: "22px",
    left: "3px",
    bottom: "3px",
    backgroundColor: "white",
    transition: "0.3s",
    borderRadius: "50%",
  });
  slider.appendChild(circle);
  toggleWrapper.appendChild(toggleCheckbox);
  toggleWrapper.appendChild(slider);

  toggleCheckbox.addEventListener("change", () => {
    if (toggleCheckbox.checked) {
      // Dark mode
      slider.style.backgroundColor = "#0F3CC9";
      circle.style.transform = "translateX(22px)";
      modal.style.background = darkTheme.cardBackground;
      modal.style.color = darkTheme.cardFont;
      applyThemeTokens(darkTheme);
      applyPopupThemeColors();
      cardFontColor = darkTheme.cardFont;
      cardBackgroundColor = darkTheme.cardBackground;
      ((cardFontColor = darkTheme.cardFont),
        // saveBtn.style.background = darkTheme.buttonBackground;
        (allowBtn.style.background = darkTheme.buttonBackground));
      allowBtn.style.color = darkTheme.buttonFont;

      btn1BackgroundColor = darkTheme.buttonFont;
      btn1FontColor = darkTheme.buttonBackground;
      btn2BackgroundColor = darkTheme.buttonBackground;
      btn2FontColor = darkTheme.buttonFont;

      saveBtn.style.background = darkTheme.buttonFont;
      saveBtn.style.color = darkTheme.buttonBackground;
      // path.setAttribute("stroke", darkTheme.buttonBackground);
      // path2.setAttribute("stroke", darkTheme.buttonBackground);
      checkboxLabel.style.color = darkTheme.cardFont;
      documentLink.style.color = darkTheme.linkFont;
      linkFontColor = darkTheme.linkFont;
      closeBtn.style.color = darkTheme.buttonBackground;
      arrow2.style.color = darkTheme.buttonBackground;
      arrow.style.color = darkTheme.buttonBackground;
      container.style.color = darkTheme.cardFont;
      container2.style.color = darkTheme.cardFont;
      applySubAccordionBodyTheme();

      // buttonBackgroundColor = darkTheme.buttonBackground;
      // buttonFontColor = darkTheme.buttonFont;
    } else {
      // Light mode
      slider.style.backgroundColor = "#ccc";
      circle.style.transform = "translateX(0)";
      modal.style.background = lightTheme.cardBackground;
      modal.style.color = lightTheme.cardFont;
      // saveBtn.style.background = lightTheme.buttonBackground;
      allowBtn.style.background = lightTheme.buttonBackground;
      allowBtn.style.color = lightTheme.buttonFont;
      applyThemeTokens(lightTheme);
      applyPopupThemeColors();

      saveBtn.style.background = lightTheme.buttonFont;
      saveBtn.style.color = lightTheme.buttonBackground;
      btn1BackgroundColor = lightTheme.buttonFont;
      btn1FontColor = lightTheme.buttonBackground;
      btn2BackgroundColor = lightTheme.buttonBackground;
      btn2FontColor = lightTheme.buttonFont;

      // path.setAttribute("stroke", lightTheme.buttonBackground);
      // path2.setAttribute("stroke", lightTheme.buttonBackground);
      cardBackgroundColor = lightTheme.cardBackground;
      cardFontColor = lightTheme.cardFont;
      checkboxLabel.style.color = lightTheme.cardFont;
      documentLink.style.color = lightTheme.linkFont;
      linkFontColor = lightTheme.linkFont;
      closeBtn.style.color = lightTheme.buttonBackground;
      arrow2.style.color = lightTheme.buttonBackground;
      arrow.style.color = lightTheme.buttonBackground;
      container.style.color = lightTheme.cardFont;
      container2.style.color = lightTheme.cardFont;
      cardFontColor = lightTheme.cardFont;
      applySubAccordionBodyTheme();
      // buttonBackgroundColor = lightTheme.buttonBackground;
      // buttonFontColor = lightTheme.buttonFont;
    }
  });
  // Repaints everything driven by the accordion / badge / dropdown theme
  // tokens. Called whenever the dark-light toggle flips, after the tokens
  // themselves have been re-read from the active theme.
  function applyPopupThemeColors() {
    header.style.background = mainAccordionBackgroundColor;
    header.style.color = mainAccordionFontColor;
    label.style.color = mainAccordionFontColor;

    header2.style.background = mainAccordionBackgroundColor;
    header2.style.color = mainAccordionFontColor;
    label2.style.color = mainAccordionFontColor;

    // Badge background stays white in both themes
    badge.style.background = activeBadgeBackgroundColor;
    badge.style.color = activeBadgeFontColor;

    dropdown.style.color = languageDropdownFontColor;
    select.style.color = languageDropdownFontColor;
    select.style.background = languageDropdownBackgroundColor;
    Array.from(select.options).forEach((opt) => {
      opt.style.color = languageDropdownFontColor;
      opt.style.background = languageDropdownBackgroundColor;
    });

    applySubAccordionTheme();
  }

  const style = document.createElement("style");
  style.textContent = `
  .custom-modal {
    scrollbar-width: none; /* Firefox */
  }
  .custom-modal::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }

  .consent-purpose-container .purpose-nested-accordion {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
    width: 100%;
  }

  .consent-purpose-container .purpose-nested-accordion:last-child {
    border-bottom: none;
  }

  .consent-purpose-container .purpose-nested-accordion__summary {
    display: flex;
    flex-direction: row;
    /* centred so the chevron and checkbox line up with multi-line purpose text,
       matching the Required / Others headers */
    align-items: center;
    gap: 0;
    padding: 12px 16px;
    cursor: pointer;
    user-select: none;
    list-style: none;
    font-family: ${fontFamily}, Inter, Arial, sans-serif;
    font-size: 14px;
    color: inherit;
  }

  .consent-purpose-container .purpose-nested-accordion__summary::-webkit-details-marker,
  .consent-purpose-container .purpose-nested-accordion__summary::marker {
    display: none;
    content: "";
  }

  .consent-purpose-container .purpose-nested-accordion__arrow {
    display: block;
    flex: 0 0 30px;
    width: 30px;
    height: 30px;
    transition: transform 0.3s ease;
  }

  .consent-purpose-container .purpose-nested-accordion[open] > .purpose-nested-accordion__summary .purpose-nested-accordion__arrow {
    transform: rotate(180deg);
  }

  .consent-purpose-container .purpose-nested-accordion__title {
    flex: 1;
    line-height: 1.4;
    padding-right: 8px;
    min-width: 0;
    font-size: 16px;
  }

  .consent-purpose-container .purpose-label,
  .consent-purpose-container .consent-label {
    font-weight: 500;
  }

  .consent-purpose-container .purpose-value,
  .consent-purpose-container .consent-value {
    font-weight: 500;
  }

  .consent-purpose-container .purpose-nested-accordion__checkbox {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex: 0 0 auto;
  }

  .consent-purpose-container .purpose-nested-accordion__input {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.65);
    cursor: pointer;
  }

  .consent-purpose-container .purpose-nested-accordion__body {
    display: grid;
    grid-template-columns: 1fr;
    gap: 5px;
    /* rows start at the card's left padding, level with the chevron */
    padding: 12px 16px 12px 16px;
    font-family: ${fontFamily}, Inter, Arial, sans-serif;
    font-size: 14px;
  }

  .consent-purpose-container .purpose-nested-accordion__body hr {
    border: 0;
    border-top: 1px solid #ddd;
    margin: 10px 0;
    width: 100%;
  }

  @media (max-width: 768px) {
    .consent-button-container {
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 12px !important;
    }

    .consent-action-btn {
      width: 100% !important;
      max-width: none !important;
    }
  }

  @media (max-width: 329px) {
    .consent-title-container {
      flex-wrap: wrap !important;
      row-gap: 8px !important;
    }

    .consent-title-left {
      display: contents !important;
    }

    .consent-title-heading {
      order: 1;
      flex: 1 1 auto;
      min-width: 0;
      margin: 0;
    }

    .consent-header-logo {
      order: 2;
      flex: 0 0 auto;
    }

    .consent-lang-dropdown {
      order: 3;
      width: 100%;
      display: flex !important;
      justify-content: flex-end !important;
    }
  }

  .others-master-cb:not(:checked) {
    -webkit-appearance: none;
    appearance: none;
    background-color: rgba(0, 0, 0, 0.30);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M18 12a1 1 0 01-1 1H7a1 1 0 010-2h10a1 1 0 011 1z' fill='white'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    border: none !important;
  }
`;
  const firstContainer = document.createElement("div");
  Object.assign(firstContainer.style, {
    display: "flex",
    justifyContent: "flex-end",
    margin: 0,
    padding: "10px 0px",
    position: "sticky",
  });

  const closeBtn = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "svg",
  );
  closeBtn.setAttribute("width", "30");
  closeBtn.setAttribute("height", "30");
  closeBtn.setAttribute("viewBox", "0 0 25 25");

  const line1 = document.createElementNS("http://www.w3.org/2000/svg", "line");
  line1.setAttribute("x1", "6");
  line1.setAttribute("y1", "6");
  line1.setAttribute("x2", "18");
  line1.setAttribute("y2", "18");
  line1.setAttribute("stroke", "rgba(10, 40, 133, 1)");
  line1.setAttribute("stroke-width", "2.5");
  line1.setAttribute("stroke-linecap", "round");

  const line2 = document.createElementNS("http://www.w3.org/2000/svg", "line");
  line2.setAttribute("x1", "18");
  line2.setAttribute("y1", "6");
  line2.setAttribute("x2", "6");
  line2.setAttribute("y2", "18");
  line2.setAttribute("stroke", "rgba(10, 40, 133, 1)");
  line2.setAttribute("stroke-width", "2.5");
  line2.setAttribute("stroke-linecap", "round");

  // closeBtn.appendChild(line1);
  // closeBtn.appendChild(line2);
  closeBtn.innerHTML = `<path d="M13.41 12l6.3-6.29a1.004 1.004 0 00-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 10-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 000 1.42 1 1 0 001.42 0l6.29-6.3 6.29 6.3a1.001 1.001 0 001.639-.325 1 1 0 00-.22-1.095L13.41 12z" fill="currentColor"></path>`;

  closeBtn.style.cursor = "pointer";
  closeBtn.style.color = buttonBackgroundColor;
  closeBtn.addEventListener("click", () => {
    // window.location.href = "/loggedIn";
    overlay.remove();
    toggleWrapper.remove();
    window.location.replace(cburl);
  });

  firstContainer.appendChild(closeBtn);

  const langIcon = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "svg",
  );
  langIcon.setAttribute("width", "32");
  langIcon.setAttribute("height", "32");
  langIcon.setAttribute("viewBox", "0 0 32 32");
  Object.assign(langIcon.style, {
    display: "inline-block",
  });

  const textA = document.createElementNS("http://www.w3.org/2000/svg", "text");
  textA.setAttribute("x", "2");
  textA.setAttribute("y", "22");
  textA.setAttribute("font-size", "25");
  textA.setAttribute("font-family", "Arial, sans-serif");
  textA.setAttribute("font-weight", "bold");
  textA.setAttribute("fill", "black");
  textA.textContent = "A";

  const textHindi = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "text",
  );
  textHindi.setAttribute("x", "16");
  textHindi.setAttribute("y", "22");
  textHindi.setAttribute("font-size", "20");
  textHindi.setAttribute("font-family", "Arial, sans-serif");
  textHindi.setAttribute("font-weight", "bold");
  textHindi.setAttribute("fill", "black");
  textHindi.textContent = "अ";

  langIcon.appendChild(textA);
  langIcon.appendChild(textHindi);

  const titleContainer = document.createElement("div");
  titleContainer.className = "consent-title-container";
  Object.assign(titleContainer.style, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
    marginTop: "0.5rem",
    position: "sticky",
  });

  const titleLeftContainer = document.createElement("div");
  titleLeftContainer.className = "consent-title-left";
  Object.assign(titleLeftContainer.style, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.5rem",
  });

  title = document.createElement("h2");
  title.className = "consent-title-heading";
  title.innerText = "Manage Consent";
  Object.assign(title.style, {
    fontWeight: "900",

    fontSize: "24px",
  });

  const logo = document.createElement("img");
  logo.className = "consent-header-logo";
  logo.src = logoUrl;
  Object.assign(logo.style, {
    width: "32px",
    height: "32px",
    objectFit: "contain",
  });
  titleLeftContainer.appendChild(title);
  // Main container
  const container_2 = document.createElement("div");
  container_2.className = "consent-lang-dropdown";
  Object.assign(container_2.style, {
    position: "relative",
    display: "flex",
    borderRadius: "20px",
    cursor: "pointer",
    justifyContent: "space-between",
    alignItems: "center",
  });

  // Dropdown wrapper
  const dropdown = document.createElement("div");
  Object.assign(dropdown.style, {
    position: "relative",
    display: "inline-block",
    alignItems: "center",
    // The language / chevron icons paint with currentColor
    color: languageDropdownFontColor,
  });

  const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  icon.setAttribute("width", "20");
  icon.setAttribute("height", "20");
  icon.setAttribute("viewBox", "0 0 25 25");
  Object.assign(icon.style, {
    position: "absolute",
    top: "50%",
    left: "10px",
    transform: "translateY(-50%)",
    pointerEvents: "none",
  });

  icon.innerHTML = `<path d="M21.71 4.29A1 1 0 0021 4h-2.23a1 1 0 00-.71.29 1 1 0 00-.29.71 1 1 0 001 1H19v1.48a2 2 0 01-.85.09 2.3 2.3 0 01-.81-.24A2.29 2.29 0 0016 4.1a2.3 2.3 0 00-2.62.9 1 1 0 00-.15.75 1 1 0 00.43.63 1 1 0 001.39-.28.36.36 0 01.14-.1.54.54 0 01.18 0 .4.4 0 01.15.1.28.28 0 01.07.17.32.32 0 01-.08.21.309.309 0 01-.22.09 1 1 0 00-.92.615 1 1 0 00-.08.385 1 1 0 00.3.7 1 1 0 00.7.3.76.76 0 01.42.12.7.7 0 01.27.34.779.779 0 01.05.43.72.72 0 01-.21.38.78.78 0 01-.38.2A.71.71 0 0115 10a.82.82 0 01-.34-.27.791.791 0 01-.12-.42 1 1 0 00-2 0 2.73 2.73 0 004.56 2.05 2.72 2.72 0 00.9-1.81c.133.01.267.01.4 0 .2.014.402.008.6-.02v1.56c.004.265.108.518.29.71a1.001 1.001 0 001.42 0 1.05 1.05 0 00.29-.71V6a1 1 0 00.71-.29A1.05 1.05 0 0022 5a.999.999 0 00-.29-.71zm-12.28.34a1 1 0 00-1.86 0l-5.5 14a1 1 0 000 .77c.11.24.307.428.55.53a1 1 0 00.77 0c.24-.11.429-.307.53-.55L5.65 15h5.7l1.72 4.37c.049.119.12.228.21.32.09.097.2.175.32.23a1.07 1.07 0 00.79.01c.12-.049.228-.12.32-.21.097-.09.176-.2.23-.32A.998.998 0 0015 19a1.067 1.067 0 00-.07-.39L9.43 4.63zm-3 8.37L8.5 7.73 10.57 13H6.43z" fill="currentColor"/>`;

  const icon2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  icon2.setAttribute("width", "20");
  icon2.setAttribute("height", "20");
  icon2.setAttribute("viewBox", "0 0 25 25");
  Object.assign(icon2.style, {
    position: "absolute",
    top: "50%",
    right: "10px",
    transform: "translateY(-50%)",
    pointerEvents: "none",
  });
  // Default icon2 (down chevron)
  const downPath = `<path d="M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z" fill="currentColor"></path>`;

  // Up chevron
  const upPath = `<path d="M16 15a.998.998 0 01-.71-.29L12 11.41l-3.29 3.3a1.004 1.004 0 01-1.42-1.42l4-4a.999.999 0 011.42 0l4 4A1.001 1.001 0 0116 15z" fill="currentColor"></path>`;

  // Set default icon
  icon2.innerHTML = downPath;

  // When dropdown opens (focus) → show up chevron

  const languages = [
    "English",
    "Hindi",
    "Bengali",
    "Tamil",
    "Telugu",
    "Kannada",
    "Malayalam",
    "Gujarati",
    "Marathi",
    "Odia",
    "Punjabi",
    "Assamese",
    "Nepali",
    "Sindhi",
    "Kashmiri",
    "Dogri",
    "Konkani",
    "Maithili",
    "Sanskrit",
    "Santali",
    "Bodo",
    "Manipuri",
  ];

  // select dropdown
  select = document.createElement("select");
  Object.assign(select.style, {
    padding: "6px 30px 6px 35px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "20px",
    cursor: "pointer",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    color: languageDropdownFontColor,
    background: languageDropdownBackgroundColor,
  });
  languages.forEach((lang) => {
    option = document.createElement("option");
    option.value = lang.toUpperCase(); // Use uppercase key for mapping
    option.innerText = lang;
    option.style.color = languageDropdownFontColor;
    option.style.background = languageDropdownBackgroundColor;

    select.appendChild(option);
    if (langRecieved) {
      select.value = langRecieved.toUpperCase();
    }
  });

  let isOpen = false;

  // First click -> open
  select.addEventListener("mousedown", () => {
    if (!isOpen) {
      icon2.innerHTML = upPath;
      isOpen = true;
    } else {
      // Second click closes dropdown
      icon2.innerHTML = downPath;
      isOpen = false;
    }
  });

  // When selection is made
  select.addEventListener("change", () => {
    icon2.innerHTML = downPath;
    isOpen = false;
  });

  // When clicking outside
  select.addEventListener("blur", () => {
    icon2.innerHTML = downPath;
    isOpen = false;
  });

  select.addEventListener("change", (e) => {
    const selectedLangKey = e.target.value;
    changeDesc(selectedLangKey);
  });

  dropdown.appendChild(icon);
  dropdown.appendChild(select);
  dropdown.appendChild(icon2);

  container_2.appendChild(dropdown);
  titleLeftContainer.appendChild(container_2);
  titleContainer.appendChild(titleLeftContainer);

  titleContainer.appendChild(logo);

  TopDesc = document.createElement("p");
  TopDesc.innerHTML = `${topDesc}`;
  TopDesc.style.marginTop = "1rem";
  TopDesc.style.marginBottom = "1rem";
  TopDesc.style.fontSize = "14px";
  // TopDesc.style.color = cardFontColor;
  TopDesc.style.fontWeight = "500";

  const customerId = document.createElement("p");

  labelSpan = document.createElement("span");
  labelSpan.innerText = translatedLabel;
  labelSpan.style.fontWeight = "700";
  labelSpan.style.fontSize = "16px";

  const valueSpan = document.createElement("span");
  valueSpan.innerText = `: ${cusId}`;
  valueSpan.style.fontWeight = "400";
  valueSpan.style.fontSize = "16px";

  customerId.appendChild(labelSpan);
  customerId.appendChild(valueSpan);

  document.body.appendChild(customerId);
  const mainBody = document.createElement("div");

  Object.assign(mainBody.style, {
    height: "350px",

    overflow: "auto",

    scrollbarWidth: "none",
  });

  const accordion = document.createElement("div");
  Object.assign(accordion.style, {
    margin: "10px 0",
    fontFamily: fontFamily,
    width: "100%",
    border: "1px solid rgba(224, 224, 224, 1)",
    borderRadius: "12px",
    overflow: "hidden",
  });

  const header = document.createElement("div");
  Object.assign(header.style, {
    display: "grid",
    gridTemplateColumns: "30px 1fr auto",
    alignItems: "center",
    padding: "12px 16px",
    cursor: "pointer",
    userSelect: "none",
    background: mainAccordionBackgroundColor,
    color: mainAccordionFontColor,
  });
  const arrow = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  arrow.setAttribute("width", "30");
  arrow.setAttribute("height", "30");
  arrow.setAttribute("viewBox", "5 0 12 23");
  arrow.style.transition = "transform 0.3s ease";
  arrow.style.color = buttonBackgroundColor;
  arrow.style.transform = "rotate(180deg)";
  arrow.innerHTML = `<path d="M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z" fill="currentColor"></path>`;

  label = document.createElement("span");
  label.innerText = requiredLabel;
  label.style.fontWeight = "700";
  label.style.fontSize = "16px";
  label.style.fontFamily = fontFamily;
  label.style.color = mainAccordionFontColor;

  header.appendChild(arrow);
  header.appendChild(label);

  badge = document.createElement("span");
  badge.innerText = "Always Active";
  Object.assign(badge.style, {
    border: "1px solid rgba(181, 181, 181, 1)",
    borderRadius: "80px",
    padding: "4px 12px",
    fontSize: "12px",
    fontFamily: fontFamily,
    fontWeight: 500,
    // Badge background stays white in both light and dark mode
    background: activeBadgeBackgroundColor,
    color: activeBadgeFontColor,
  });

  // Required purposes are always granted, so this checkbox is purely indicative:
  // permanently checked and disabled, it drives no consent state.
  const reqCheckbox = document.createElement("input");
  reqCheckbox.type = "checkbox";
  reqCheckbox.checked = true;
  reqCheckbox.disabled = true;
  Object.assign(reqCheckbox.style, {
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    accentColor: buttonBackgroundColor,
    cursor: "not-allowed",
    margin: "0",
  });

  // Grid is "30px 1fr auto", so badge + checkbox share the last column
  const reqRight = document.createElement("div");
  Object.assign(reqRight.style, {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  });
  reqRight.appendChild(badge);
  reqRight.appendChild(reqCheckbox);

  header.appendChild(reqRight);

  content = document.createElement("div");
  Object.assign(content.style, {
    display: "block",
    fontSize: "14px",
    color: cardFontColor,
    fontFamily: fontFamily,
  });

  const container = document.createElement("div");
  container.className = "consent-purpose-container";
  // Build a translation map after getting data2 from translation API
  // const keyTranslations = {};
  // [
  //   "Purpose",
  //   "Data item",
  //   "Processing activity",
  //   "Used by",
  //   "Duration",
  //   "Id",
  // ].forEach((key) => {
  //   const obj = data2.output.find((o) => o.id === key);
  //   keyTranslations[key] = obj ? obj.target : key;
  // });

  // Render templateList1 with translated labels
  templateList1.forEach((template) => {
    container.appendChild(
      buildPurposeAccordionItem(template, {
        keyTranslations,
        arrowColor: buttonBackgroundColor,
        cardColor: cardFontColor,
      }),
    );
  });

  content.appendChild(container);

  Object.assign(arrow.style, {
    display: "inline-block",
    verticalAlign: "middle",
    marginRight: "6px",
  });

  Object.assign(label.style, {
    fontWeight: "700",
    fontSize: "16px",
    fontFamily: fontFamily,
    verticalAlign: "middle",
  });

  // Toggle open/close
  header.addEventListener("click", () => {
    const isOpen = content.style.display === "block";

    if (isOpen) {
      // Currently open close it
      content.style.display = "none";
      arrow.style.transform = "rotate(0deg)";
    } else {
      // Currently closed open it
      content.style.display = "block";
      arrow.style.transform = "rotate(180deg)";
    }
  });

  if (templateList1.length > 0) {
    accordion.appendChild(header);
    accordion.appendChild(content);
  }

  const accordion2 = document.createElement("div");
  Object.assign(accordion2.style, {
    margin: "10px 0",
    fontFamily: fontFamily,
    width: "100%",
    border: "1px solid rgba(224, 224, 224, 1)",
    borderRadius: "12px",
    overflow: "hidden",
  });

  const header2 = document.createElement("div");
  Object.assign(header2.style, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 16px",
    cursor: "pointer",
    userSelect: "none",
    background: mainAccordionBackgroundColor,
    color: mainAccordionFontColor,
  });

  const left2 = document.createElement("div");
  Object.assign(left2.style, {
    display: "flex",
    alignItems: "center",
  });

  const arrow2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  arrow2.setAttribute("width", "30");
  arrow2.setAttribute("height", "30");
  arrow2.setAttribute("viewBox", "5 0 12 23");
  arrow2.style.transition = "transform 0.3s ease";
  arrow2.style.color = buttonBackgroundColor;
  arrow2.style.transform = "rotate(180deg)";
  arrow2.innerHTML = `<path d="M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z" fill="currentColor"></path>`;

  label2 = document.createElement("span");
  label2.innerText = "Others";
  label2.style.fontWeight = "700";
  label2.style.fontSize = "16px";
  label2.style.fontFamily = fontFamily;
  label2.style.color = mainAccordionFontColor;

  left2.appendChild(arrow2);
  left2.appendChild(label2);

  checkbox2 = document.createElement("input");
  checkbox2.type = "checkbox";
  checkbox2.className = "others-master-cb";
  Object.assign(checkbox2.style, {
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    border: "1px solid rgba(0,0,0,0.65)",
    cursor: "pointer",
    accentColor: buttonBackgroundColor,
  });

  checkbox2.addEventListener("change", () => {
    const checked = checkbox2.checked;
    rowCheckboxes.forEach(({ checkbox, prefId }) => {
      checkbox.checked = checked;
      if (checked) {
        consentArray[prefId] = "ACCEPTED";
      } else {
        delete consentArray[prefId];
      }
    });
  });

  header2.appendChild(left2);
  header2.appendChild(checkbox2);

  content2 = document.createElement("div");
  Object.assign(content2.style, {
    display: "block",
    fontSize: "14px",
    color: cardFontColor,
    fontFamily: fontFamily,
  });
  const container2 = document.createElement("div");
  container2.className = "consent-purpose-container";

  // const rowCheckboxes = [];
  templateList2.forEach((template) => {
    container2.appendChild(
      buildPurposeAccordionItem(template, {
        keyTranslations,
        showCheckbox: true,
        preferenceId: template.Id,
        arrowColor: buttonBackgroundColor,
        cardColor: cardFontColor,
        syncMasterCheckbox: true,
      }),
    );
  });

  content2.appendChild(container2);

  header2.addEventListener("click", () => {
    const isOpen = content2.style.display === "block";

    if (isOpen) {
      // Currently open -> close it
      content2.style.display = "none";
      arrow2.style.transform = "rotate(0deg)";
    } else {
      // Currently closed- >open it
      content2.style.display = "block";
      arrow2.style.transform = "rotate(180deg)";
    }
  });
  if (templateList2.length > 0) {
    accordion2.appendChild(header2);
    accordion2.appendChild(content2);
  }

  documentLink = document.createElement("p");
  documentLink.innerText = `${doc_name}`;
  Object.assign(documentLink.style, {
    color: linkFontColor,
    fontWeight: "700",
    cursor: "pointer",
    margin: "10px 0",
    fontSize: "14px",
    marginBottom: "1rem",
    marginTop: "1rem",
  });

  documentLink.addEventListener("click", async () => {
    if (!pdfUrl) {
      pdfUrl = await fetchDocument(doc_id);
    }
    if (pdfUrl) {
      window.open(pdfUrl, "_blank"); // Opens PDF in new tab
    }
  });

  const checkboxContainer = document.createElement("div");
  Object.assign(checkboxContainer.style, {
    marginTop: "10px",
    marginBottom: "15px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  });

  checkbox = document.createElement("input");
  checkbox.type = "checkbox";
  Object.assign(checkbox.style, {
    width: "16px",
    height: "16px",
    cursor: "pointer",
    borderRadius: "4px",
    border: "1px solid rgba(181, 181, 181, 1)",
    accentColor: buttonBackgroundColor,
  });
  // If isParental is true, checkbox should be checked and disabled
  if (isParental) {
    checkbox.checked = true;
    checkbox.disabled = true;
    parentalFlow = true;
  }

  checkbox.addEventListener("change", function () {
    if (checkbox.checked) {
      // openUnder18Modal();
      parentalFlow = true;
    } else {
      parentalFlow = false;
    }
  });

  checkboxLabel = document.createElement("label");
  checkboxLabel.innerText = "I am below 18 years of age.";
  checkboxLabel.style.cursor = "pointer";
  checkboxLabel.style.fontSize = "14px";
  // checkboxLabel.style.color = "rgba(0, 0, 0, 0.65)";
  checkboxLabel.style.fontWeight = "bold";
  checkboxContainer.appendChild(checkbox);
  checkboxContainer.appendChild(checkboxLabel);

  const withdrawContainer = document.createElement("p"); // or "p"

  Object.assign(withdrawContainer.style, {
    fontFamily: fontFamily,
    marginTop: "5px",
    fontSize: "14px",
    fontWeight: 500,
    marginBottom: "1rem",
  });

  // Make withdrawLine inline
  withdrawLine = document.createElement("span");
  withdrawLine.innerHTML = `${rightsDesc} `;

  clickHere = document.createElement("span");
  clickHere.innerText = "click here";
  Object.assign(clickHere.style, {
    color: linkFontColor,
    fontWeight: "700",
    cursor: "pointer",
  });

  withdrawContainer.appendChild(withdrawLine);
  // withdrawContainer.appendChild(clickHere);

  ConsentAllow = document.createElement("p");
  ConsentAllow.innerHTML = `${permissionText}`;
  ConsentAllow.style.marginTop = "5px";
  ConsentAllow.style.fontSize = "14px";
  // ConsentAllow.style.color = cardFontColor;
  ConsentAllow.style.fontWeight = "500";
  ConsentAllow.style.fontFamily = fontFamily;

  const buttonContainer = document.createElement("div");
  buttonContainer.className = "consent-button-container";
  Object.assign(buttonContainer.style, {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "20px",
    position: "sticky",
  });
  saveBtn = document.createElement("button");
  saveBtn.className = "consent-action-btn";
  saveBtn.innerText = "Save My Choices";
  Object.assign(saveBtn.style, {
    background: buttonFontColor,
    color: buttonBackgroundColor,
    border: "1px solid rgba(181, 181, 181, 1)",
    padding: "12px 24px",
    borderRadius: "250px",
    fontWeight: "700",
    fontSize: "18px",
    fontFamily: fontFamily,
    cursor: "pointer",
    textAlign: "center",
    whiteSpace: "normal",
    wordBreak: "break-word",
    width: "auto",
    maxWidth: "15rem",
    // maxWidth: "250px",
  });
  saveBtn.addEventListener("click", () => {
    captureConsent(consentArray);
  });

  allowBtn = document.createElement("button");
  allowBtn.className = "consent-action-btn";
  allowBtn.innerText = "Allow All";
  // Object.assign(allowBtn.style, {
  //   background: buttonBackgroundColor,
  //   color: buttonFontColor,
  //   border: "none",
  //   padding: "12px 24px",
  //   borderRadius: "250px",
  //   cursor: "pointer",
  //   fontWeight: "700",
  //   fontSize: "18px",
  //   fontFamily: "system-ui",
  //   textAlign: "center",
  //   whiteSpace: "nowrap",
  //   minWidth: "150px", // fallback
  // });

  Object.assign(allowBtn.style, {
    background: buttonBackgroundColor,
    color: buttonFontColor,
    border: "1px solid rgba(181, 181, 181, 1)",
    padding: "12px 24px",
    borderRadius: "250px",
    fontWeight: "700",
    fontSize: "18px",
    fontFamily: fontFamily,
    cursor: "pointer",
    textAlign: "center",
    whiteSpace: "normal",
    wordBreak: "break-word",
    width: "auto",
    maxWidth: "15rem",
    // maxWidth: "250px",
  });
  allowBtn.addEventListener("click", () => {
    // Check the header checkbox
    checkbox2.checked = true;

    // Check all row checkboxes and update consentArray
    rowCheckboxes.forEach(({ checkbox, prefId }) => {
      checkbox.checked = true;
      consentArray2[prefId] = "ACCEPTED";
    });

    captureAllConsent(consentArray2);
  });

  buttonContainer.appendChild(saveBtn);
  buttonContainer.appendChild(allowBtn);

  modal.appendChild(firstContainer);
  modal.appendChild(titleContainer);
  mainBody.appendChild(TopDesc);
  mainBody.appendChild(customerId);
  // Only mount an accordion card when it has content, otherwise an empty
  // bordered box shows up as a stray line above/below the one that is shown
  if (templateList1.length > 0) {
    mainBody.appendChild(accordion);
  }
  if (templateList2.length > 0) {
    mainBody.appendChild(accordion2);
  }
  mainBody.appendChild(documentLink);
  if (parentalControl == true) {
    mainBody.appendChild(checkboxContainer);
  }

  mainBody.appendChild(withdrawContainer);
  mainBody.appendChild(ConsentAllow);
  modal.appendChild(mainBody);
  modal.appendChild(buttonContainer);
  overlay.appendChild(modal);
  overlay.appendChild(style);

  document.body.appendChild(overlay);
  if (darkModeVisibility == true) {
    document.body.appendChild(toggleWrapper);
  }
};

export default loadPreferenceCenter;
